const pt = {
  // Palavras e frases comuns
  common: {
    back: "Voltar",
    search: "Buscar",
    filter: "Filtrar",
    clear: "Limpar",
    export: "Exportar",
    currency: "Moeda",
    country: "País",
    download: "Baixar",
    loading: "Carregando...",
    saving: "Salvando...",
    save: "Salvar",
    save_changes: "Salvar Alterações",
    apply: "Aplicar",
    cancel: "Cancelar",
    delete: "Excluir",
    edit: "Editar",
    view: "Ver",
    add: "Adicionar",
    name: "Nome",
    email: "E-mail",
    password: "Senha",
    confirm: "Confirmar",
    submit: "Enviar",
    error: "Erro",
    success: "Sucesso",
    warning: "Aviso",
    info: "Informação",
    yes: "Sim",
    no: "Não",
    all: "Todos",
    none: "Nenhum",
    select: "Selecionar",
    for: "para",
    in: "em",
    showMore: "Ver Mais",
    next: "Próximo",
    previous: "Anterior",
    showLess: "Ver Menos",
    clearFilter: "Limpar filtro",
    searchCountry: "Buscar países...",
    page: "Página",
    merchant: "Estabelecimento",
    description: "Descrição",
    account: "Conta",
    type: "Tipo",
    date: "Data",
    amount: "Valor",
    category: "Categoria",
    transactions: "Transações",
    total: "Total",
    actions: "Ações",
    viewReport: "Ver Relatório",
    other: "Outro",
    selectCountries: "Selecionar países",
    noCountryFound: "Nenhum país encontrado.",
    continue: "Continuar",
    or: "ou",
  },

  // Relacionado ao tempo
  time: {
    today: "Hoje",
    yesterday: "Ontem",
    thisWeek: "Esta Semana",
    lastWeek: "Semana Passada",
    thisMonth: "Este Mês",
    lastMonth: "Mês Passado",
    thisYear: "Este Ano",
    lastYear: "Ano Passado",
    custom: "Personalizado",
    from: "De",
    to: "Até",
    now: "Agora",
    quarter: "Trimestre",
    year: "Ano",
    month: "Mês",
    period: "Período",
    startMonth: "Mês Inicial",
    endMonth: "Mês Final",
    startQuarter: "Trimestre Inicial",
    endQuarter: "Trimestre Final",
    lastQuarter: "Últimos 90 dias",
    allTime: "Todo o período",
  },

  // Navegação e menus
  nav: {
    passiveIncome: "Renda passiva",
    dashboard: "Painel",
    transactions: "Transações",
    accounts: "Contas",
    categories: "Categorias",
    reports: "Relatórios",
    settings: "Configurações",
    users: "Usuários",
    logout: "Sair",
    login: "Entrar",
    register: "Cadastrar",
    profile: "Perfil",
    preferences: "Preferências",
    help: "Ajuda",
    support: "Suporte",
    about: "Sobre",
    currencyRates: "Taxas de Câmbio",
    financialSummary: "Resumo Financeiro",
    portfolioHoldings: "Carteira de Investimentos",
    tagAnalytics: "Análise por Tags",
    equityAnalysis: "Análise de Ações",
    expenses: "Despesas",
    agents: "Agentes Bliss",
    importAgent: "Agente de Importação",
    insightAgent: "Insights de IA",
    travelAgent: "Agente de Viagens",
    manageAssets: "Gerir ativos",
    assetsLiabilities: "Ativos e Passivos",
    transactionReview: "Revisão de Transações",
    subscriptions: "Assinaturas",
  },

  // Títulos e descrições de páginas
  pages: {
    oauth: {
      consent: {
        title: "Conectar {{client}} ao Bliss",
        subtitle: "Este app quer usar seus dados do Bliss pelo servidor MCP.",
        signed_in_as: "Conectado como {{email}}",
        redirect_notice: "Depois da sua decisão, você voltará para",
        access_label: "Acesso",
        read_only_description: "Ver transações, carteira, análises e insights. Não pode alterar nada.",
        read_write_description: "Também recategorizar transações, tratar suas filas de revisão e editar dados da carteira.",
        expiry_label: "A conexão expira após",
        no_expiry_warning: "Uma conexão sem validade continua funcionando até você revogá-la.",
        footnote: "O app vê seus dados financeiros descriptografados. Você pode revogar a conexão a qualquer momento em Configurações → Integrações.",
        admin_required: "Só um administrador do espaço pode conectar apps. Peça a um administrador para conectar.",
        allow: "Permitir",
        deny: "Recusar",
        error_title: "Não foi possível concluir esta conexão",
        error_missing: "Este link está incompleto. Inicie a conexão novamente pelo seu app.",
        error_generic: "Algo deu errado. Inicie a conexão novamente pelo seu app.",
      },
    },
    dashboard: {
      title: "Painel",
      subtitle: "Visão geral da sua situação financeira",
      summary: "Resumo",
      recentTransactions: "Transações Recentes",
      quickActions: "Ações Rápidas",
      insights: "Insights",
      totalNetWorth: "Patrimônio Líquido Total",
    },
    accounts: {
      title: "Contas",
      subtitle: "Gerencie suas contas financeiras",
      addAccount: "Adicionar Conta",
      editAccount: "Editar Conta",
      deleteAccount: "Excluir Conta",
      accountDetails: "Detalhes da Conta",
      noAccounts: "Nenhuma conta encontrada",
      hasBeenRemoved: "foi removida",
    },
    transactions: {
      title: "Transações",
      subtitle: "Visualize e gerencie suas transações",
      addTransaction: "Adicionar Transação",
      editTransaction: "Editar Transação",
      deleteTransaction: "Excluir Transação",
      transactionDetails: "Detalhes da Transação",
      noTransactions: "Nenhuma transação encontrada",
      noTransactionsFound: "Nenhuma transação encontrada",
      tryDifferentFilters: "Tente ajustar seus filtros para encontrar o que procura.",
      filter: "Filtrar Transações",
      import: "Importar Transações",
      export: "Exportar Transações",
      allAccounts: "Todas as Contas",
      allGroups: "Todos os Grupos",
      allCategories: "Todas as Categorias",
      categoryGroup: "Grupo de Categoria",
      exportCsv: "Exportar CSV",
      importCsv: "Importar CSV",
      exportComplete: "Exportação concluída",
      csvDownloaded: "CSV baixado com sucesso",
      exportFailed: "Falha na exportação",
      exporting: "Exportando...",
      exportTransactions: "Exportar Transações",
      exportDescription: "Escolha quais transações exportar",
      currentFilters: "{{count}} transações correspondentes aos filtros atuais",
      allTransactions: "Todas as transações",
      exportingTransactions: "Exportando suas transações...",
      exportingNote: "Isso pode levar um momento. Por favor, não feche esta janela.",
      startDate: "Data Inicial",
      endDate: "Data Final",
      pickDate: "Selecionar data",
      editTransactionDescription: "Edite os detalhes desta transação.",
      addTransactionDescription: "Preencha os detalhes para adicionar uma nova transação.",
    },
    categories: {
      title: "Categorias",
      subtitle: "Gerencie suas categorias de transação",
      addCategory: "Adicionar Categoria",
      editCategory: "Editar Categoria",
      renameCategory: "Renomear Categoria",
      deleteCategory: "Excluir Categoria",
      categoryDetails: "Detalhes da Categoria",
      noCategories: "Nenhuma categoria encontrada",
      hasBeenRemoved: "foi removida",
      renameDescription: "Categorias padrão não podem ser movidas para um tipo ou grupo diferente. Você pode atualizar o nome e o ícone.",
      addNewDescription: "Preencha os detalhes para criar uma nova categoria personalizada.",
      updateDetails: "Atualize os detalhes da categoria abaixo.",
      customCategories: "Categorias Personalizadas",
      customEmpty: "Nenhuma categoria personalizada ainda. Adicione uma quando os padrões não atenderem às suas necessidades.",
      addToType: "+ Adicionar Categoria {{type}}",
      filterByGroup: "Filtrar por Grupo",
      empty: {
        title: "Nenhuma categoria encontrada",
        description: "Crie sua primeira categoria para começar.",
      },
      noMatch: {
        title: "Nenhum resultado encontrado",
        description: "Tente ajustar sua busca.",
      },
    },
    reports: {
      title: "Relatórios",
      subtitle: "Selecione um tipo de relatório para gerar análises financeiras detalhadas",
      financialSummary: {
        title: "Resumo Financeiro",
        description: "Ver receitas e despesas em diferentes períodos"
      },
      expenses: {
        title: "Controle de Despesas",
        description: "Analise padrões de gastos por categoria"
      },
      portfolio: {
        title: "Carteira de Investimentos",
        description: "Visualize e analise sua carteira de investimentos"
      },
      recentReports: {
        title: "Relatórios Recentes",
        description: "Seus relatórios gerados recentemente",
        empty: "Nenhum relatório recente encontrado.",
        hint: "Os relatórios que você gerar aparecerão aqui para acesso rápido."
      }
    },
    currencyRates: {
      title: "Taxas de Câmbio",
      subtitle: "Monitore e gerencie taxas de câmbio",
      baseCurrency: "Moeda Base",
      targetCurrency: "Moeda Alvo",
      currentRate: "Taxa Atual",
      historicalRates: "Taxas Históricas",
      updateRate: "Atualizar Taxa",
    },
    financialSummary: {
      title: "Resumo Financeiro",
      subtitle: "Ver e analisar suas receitas e despesas",
      statement: "Demonstrativo",
      trend: "Tendência Mensal",
      breakdown: "Detalhamento de receitas e despesas",
      chartDescription: "Desdobramento mensal de receitas, despesas e poupança",
      downloadStatement: "Baixar Demonstrativo Completo",
      netIncome: "Receita Líquida",
      netSavings: "Poupança Líquida",
      totalRevenue: "Receita Total",
      totalExpenses: "Despesas Totais",
      savingsRate: "Taxa de Poupança",
      topExpense: "Maior Despesa",
      discretionaryIncome: "Renda Discricionária",
      savingsCapacity: "Capacidade de Poupança",
      otherActivity: "Outra Atividade",
    },
    portfolio: {
      title: "Carteira de Investimentos",
      description: "Acompanhe e analise sua carteira de investimentos por tipo de ativo",
      subtitle: "Acompanhe e analise sua carteira de investimentos por tipo de ativo",
      totalValue: "Valor Total da Carteira",
      totalHoldings: "Em {{count}} posições",
      gainLoss: "Ganho/Perda Total",
      overallReturn: "{{value}}% de retorno geral",
      assetBreakdown: "Composição por Classe de Ativo",
      holdings: "Lista de Posições",
      allocation: "Alocação de Ativos",
      performance: "Desempenho",
      holdingsDescription: "Seus investimentos agrupados por tipo de ativo",
      allocationDescription: "Distribuição da sua carteira por tipo de ativo",
      performanceDescription: "Comparação de ganhos e perdas entre diferentes tipos de ativo",
      search: "Buscar posições...",
      assetAndType: "Ativo e Tipo",
      symbolId: "Símbolo/ID",
      qtyUnits: "Qtd/Unidades",
      currentPrice: "Preço Atual",
      marketValue: "Valor de Mercado",
      gainLossValue: "Ganho/Perda",
      percentReturn: "% Retorno"
    },
    expenses: {
      title: "Controle de Despesas",
      description: "Analise seus padrões de gastos por categoria",
      selectCategoryType: "Selecionar tipo de categoria",
      countriesSelected: "{{count}} países selecionados",
      includeCredits: {
        label: "Incluir créditos",
        tooltip: "Ativado: créditos em categorias de despesa (estornos, reembolsos, a parte de um colega de casa, indenizações de seguro) são subtraídos dos débitos. Desativado: mostra apenas os débitos."
      },
      basis: {
        net: "débitos − créditos",
        debitOnly: "apenas débitos"
      },
      timeFrame: {
        label: "Período",
        month: "Mês",
        quarter: "Trimestre",
        year: "Ano"
      },
      export: "Exportar",
      metrics: {
        totalExpenses: "Despesas Totais",
        averageMonthly: "Média Mensal",
        highestCategory: "Maior Categoria",
        monthlyAverage: "Média Mensal"
      },
      breakdown: {
        title: "Detalhamento de Despesas",
        description: "Visualize suas despesas por categoria",
        tabs: {
          byCategory: "Por Categoria",
          monthlyTrends: "Tendências Mensais",
          detailedList: "Lista Detalhada"
        },
        topCategories: "Principais Categorias de Despesa",
        netCredits: "Créditos líquidos",
        netCreditsCaption: "O total inclui {{amount}} de créditos líquidos",
        noNetSpend: "Sem gasto líquido neste período",
        trendChart: {
          movingAverageSuffix: " (média de 6 meses)"
        },
        comingSoon: {
          trends: "A visualização de tendências mensais estará disponível em breve.",
          details: "A lista detalhada de despesas estará disponível em breve."
        },
        details: {
          emptyTitle: "Selecione uma categoria para explorar",
          emptyDescription: "Clique em uma fatia do gráfico de pizza ou em uma linha de categoria para ver as transações individuais.",
          goToCategories: "Ir para Por Categoria",
          capNotice: "Mostrando as primeiras 1.000 transações; os totais podem estar incompletos",
        }
      }
    },
    settings: {
      title: "Configurações da Conta",
      description: "Gerencie as preferências e configurações da sua conta",
      language: "Idioma",
      error_loading_reference_data: "Falha ao carregar dados de referência. Por favor, atualize a página.",
      error_saving_no_id: "Não foi possível encontrar seu ID de usuário para salvar as configurações.",
      error_saving_generic: "Ocorreu um erro desconhecido ao salvar.",
      success_saving: "Suas configurações foram salvas com sucesso.",
      tabs: {
        general: "Geral",
        countries_currencies: "Países e Moedas",
        banks: "Bancos",
        connections: "Conexões",
        integrations: "Integrações",
        ai_classification: "Classificação IA",
        maintenance: "Manutenção",
        admin_section: "Administração",
        processing: "Processamento",
        bank_sync: "Sincronização bancária",
      },
      general: {
        title: "Configurações Gerais",
        description: "Configure as configurações gerais e informações do seu espaço",
        tenant_name_label: "Nome do Espaço",
        tenant_name_description: "Este é o nome da sua organização ou perfil de finanças pessoais.",
        user_management_label: "Gestão de Usuários",
        user_management_button: "Gerenciar Usuários",
        user_management_description: "Gerencie os usuários com acesso à sua conta.",
        sign_out_others: {
          label: "Outros dispositivos",
          description: "Saia em todos os lugares, exceto neste dispositivo. Seus outros navegadores e apps instalados precisarão entrar novamente.",
          button: "Sair de todos os outros dispositivos",
          confirm_title: "Sair de todos os outros dispositivos?",
          confirm_description: "Todos os outros navegadores e apps instalados conectados à sua conta serão desconectados na próxima solicitação. Este dispositivo continua conectado.",
          confirm: "Desconectar os outros",
          success: "Os outros dispositivos foram desconectados.",
          error: "Não foi possível desconectar os outros dispositivos. Tente novamente.",
        },
      },
      countries: {
        title: "Países",
        description: "Países onde você tem atividades financeiras",
        selected_label: "Países Selecionados",
        available_label: "Países Disponíveis",
        none_selected: "Nenhum país selecionado"
      },
      currencies: {
        title: "Moedas",
        description: "Moedas que você utiliza nas suas transações",
        selected_label: "Moedas Selecionadas",
        available_label: "Moedas Disponíveis",
        none_selected: "Nenhuma moeda selecionada"
      },
      banks: {
        title: "Configurações de Bancos",
        description: "Gerencie os bancos que você utiliza nas suas atividades financeiras",
        selected_label: "Seus Bancos",
        available_label: "Bancos Disponíveis",
        none_selected: "Nenhum banco selecionado"
      },
      connections: {
        title: "Conexões Plaid",
        description: "Gerencie suas conexões bancárias vinculadas e o status de sincronização",
        no_connections: "Nenhuma conexão bancária ainda. Use 'Conectar Banco' para vincular sua primeira conta.",
        status_active: "Ativa",
        status_login_required: "Login Necessário",
        status_error: "Erro",
        status_revoked: "Revogada",
        status_pending: "Pendente",
        last_sync: "Última sincronização",
        never_synced: "Nunca sincronizado",
        error_code: "Erro",
        reconnect: "Reconectar",
        reconnect_description: "Reautentique sua conexão bancária para retomar a sincronização.",
        connection_warning: "Uma ou mais conexões bancárias requerem atenção.",
        accounts_linked: "contas vinculadas",
      },
      integrations: {
        title: "Integrações e tokens de API",
        description: "Permita que agentes de IA, scripts e outros sistemas usem a API do Bliss. Cada integração tem os próprios tokens, que você pode revogar a qualquer momento.",
        create: "Nova integração",
        create_title: "Nova integração",
        add_key_title: "Adicionar uma chave",
        rename_title: "Renomear integração",
        empty: "Ainda não há integrações. Crie uma para conectar um agente de IA ou outro sistema.",
        loading_error: "Não foi possível carregar as integrações.",
        acting_note: "As solicitações com token agem em seu nome, limitadas ao nível de acesso escolhido. Se o seu usuário for excluído, suas integrações serão revogadas.",
        security_note: "Quem tiver um token pode ver seus dados financeiros descriptografados. Trate-o como a senha do seu banco.",
        access_read_only: "Somente leitura",
        access_read_write: "Leitura e escrita",
        access_read_only_description: "Pode ler transações, carteira, análises e insights. Não pode alterar nada.",
        access_read_write_description: "Também pode criar e editar transações, tags e importações, e trabalhar na fila de revisão do Plaid. Não pode gerenciar contas, categorias, usuários, conexões bancárias nem configurações.",
        status_active: "Ativa",
        status_revoked: "Revogada",
        status_expired: "Expirada",
        keys_count: "{{count}} de {{total}} chaves ativas",
        last_used: "Último uso",
        never_used: "Nunca",
        expires: "Expira",
        no_expiry: "Sem expiração",
        add_key: "Adicionar chave",
        revoke_key: "Revogar",
        revoke_integration: "Revogar integração",
        rename: "Renomear",
        show_keys: "Chaves",
        hide_keys: "Ocultar chaves",
        form: {
          name_label: "Nome",
          name_placeholder: "ex.: Agente Claude",
          name_required: "Informe um nome.",
          description_label: "Descrição (opcional)",
          access_label: "Nível de acesso",
          access_fixed: "O nível de acesso não pode ser alterado depois. Para mudá-lo, crie uma nova integração.",
          key_name_label: "Nome da chave (opcional)",
          key_name_placeholder: "ex.: Notebook",
          expiry_label: "A chave expira após",
          expiry_30: "30 dias",
          expiry_90: "90 dias",
          expiry_365: "1 ano",
          expiry_never: "Nunca",
          no_expiry_warning: "Uma chave sem expiração continua funcionando até você revogá-la.",
          create_submit: "Criar integração",
          add_key_submit: "Criar chave",
          save: "Salvar",
          cancel: "Cancelar",
        },
        reveal: {
          title: "Copie seu token",
          subtitle: "Use-o como token Bearer no cabeçalho Authorization.",
          warning: "Este token não será exibido novamente. Guarde-o em um lugar seguro, como um gerenciador de senhas.",
          copy: "Copiar",
          copied: "Copiado",
          example: "Exemplo de solicitação",
          done: "Concluir",
        },
        mcp: {
          title: "Usar com o Claude (MCP)",
          description: "Conecte o Claude Code ou outro cliente MCP com esta chave. Ele vê os mesmos dados que a chave permite: chaves somente leitura só podem ler.",
          url_label: "URL do servidor MCP:",
          copy_command: "Copiar comando",
        },
        oauth: {
          badge: "Conectada via OAuth · {{client}}",
          expires: "A conexão expira em {{date}}",
          no_expiry: "A conexão nunca expira",
        },
        confirm: {
          revoke_key_title: "Revogar esta chave?",
          revoke_key_description: "Tudo que usa esta chave deixa de funcionar na próxima solicitação. As outras chaves da integração continuam funcionando.",
          revoke_integration_title: "Revogar esta integração?",
          revoke_integration_description: "Todas as chaves deixam de funcionar imediatamente. Isso não pode ser desfeito.",
          confirm_revoke: "Revogar",
        },
        toast: {
          created: "Integração criada",
          key_created: "Chave criada",
          key_revoked: "Chave revogada",
          revoked: "Integração revogada",
          renamed: "Integração atualizada",
          error: "Algo deu errado. Tente novamente.",
        },
      },
    },
    users: {
      title: "Usuários",
      subtitle: "Gerencie contas de usuário e permissões",
      addUser: "Adicionar Usuário",
      editUser: "Editar Usuário",
      deleteUser: "Excluir Usuário",
      userDetails: "Detalhes do Usuário",
      noUsers: "Nenhum usuário encontrado",
      roles: "Funções e Permissões",
    },
    notFound: {
      title: "Página Não Encontrada",
      subtitle: "A página que você procura não existe",
      goBack: "Voltar para a página inicial",
    },
    login: {
      confirm_identity: {
        title: "Confirme que é você",
        description: "Para sua segurança, confirme sua identidade para continuar. Isso é necessário quando seu último login foi há mais de 15 minutos.",
        password_label: "Senha",
        confirm: "Confirmar",
        google: "Continuar com o Google",
        divider: "ou",
        wrong_password: "Senha incorreta. Tente novamente.",
        error: "Não foi possível confirmar sua identidade. Tente novamente.",
        no_method: "Esta conta não pode confirmar a identidade aqui. Saia, entre novamente e tente outra vez.",
      },
      title: "Entrar",
      subtitle: "Acesse sua conta",
      noAccount: "Não tem uma conta?",
      signUp: "Cadastre-se",
      rememberMe: "Lembrar de mim",
    },
    agents: {
      title: "Agentes Bliss",
      subtitle: "Assistentes financeiros com inteligência artificial",
    },
    importAgent: {
      title: "Agente de Importação",
      subtitle: "Importe e processe dados financeiros de diversas fontes",
      description: "Faça upload e categorize automaticamente transações de extratos CSV/PDF",
      dropzone: "Arraste os arquivos aqui ou clique para procurar",
      processing: "Processando seus documentos",
      success: "Importado com sucesso",
      failed: "Falha na importação",
      supportedFormats: "Formatos suportados: CSV, PDF, Excel",
      parseOptions: "Opções de análise",
      mapColumns: "Mapear colunas",
      preview: "Pré-visualizar dados",
      import: "Importar dados",
    },
    insightAgent: {
      title: "Agente de Insights",
      subtitle: "Receba insights e recomendações financeiras personalizadas",
      description: "Analise seus padrões de gastos e receba consultoria financeira personalizada",
      generating: "Gerando insights",
      noData: "Precisa de mais dados de transação para gerar insights",
      categories: "Insights por categoria",
      trends: "Tendências de gastos",
      recommendations: "Recomendações",
      savingOpportunities: "Oportunidades de economia",
      budgetSuggestions: "Sugestões de orçamento",
    },
    travelAgent: {
      title: "Agente de Viagens",
      subtitle: "Gerencie suas despesas e orçamentos de viagem",
      description: "Planeje viagens, acompanhe despesas e otimize gastos com viagem",
      upcoming: "Próximas viagens",
      past: "Viagens anteriores",
      expenses: "Despesas de viagem",
      currency: "Conversão de moeda",
      planning: "Planejamento de viagem",
      budgeting: "Orçamento de viagem",
      addTrip: "Adicionar viagem",
      editTrip: "Editar viagem",
    },
    comingSoon: {
      title: "Em Breve",
      subtitle: "Este recurso está em desenvolvimento",
      description: "Estamos trabalhando para trazer este recurso. Volte em breve!",
      backToHome: "Voltar ao Painel",
    },
    manualUpdates: {
      title: "Ativos e Passivos",
      subtitle: "Gerencie os preços dos seus ativos e termos de dívidas",
      assetsNeedingUpdate: "Ativos que Precisam de Atualização de Preço",
      liabilities: "Passivos",
      noAssetsNeedUpdate: "Todos os ativos estão atualizados.",
      noLiabilities: "Nenhum passivo encontrado.",
      lastUpdated: "Última atualização",
      daysAgo: "{{count}} dias atrás",
      updatePrice: "Atualizar Preço",
      editTerms: "Editar Termos",
      errorLoading: "Falha ao carregar dados dos ativos. Tente novamente mais tarde.",
    },
    profile: {
      title: "Perfil",
      subtitle: "Gerencie suas informações pessoais",
    },
  },

  // Campos de formulário e validação
  forms: {
    required: "Este campo é obrigatório",
    invalidEmail: "Por favor, insira um endereço de e-mail válido",
    passwordLength: "A senha deve ter pelo menos 8 caracteres",
    passwordMismatch: "As senhas não coincidem",
    invalidAmount: "Por favor, insira um valor válido",
    invalidDate: "Por favor, insira uma data válida",
    maxLength: "Tamanho máximo excedido",
    minLength: "Tamanho mínimo necessário",
    selectOption: "Por favor, selecione uma opção",
    invalidInput: "Entrada inválida",
  },

  // Cards e widgets do painel
  dashboard: {
    totalBalance: "Saldo Total",
    income: "Receita",
    expenses: "Despesas",
    savings: "Poupança",
    budget: "Orçamento",
    recentTransactions: "Transações Recentes",
    cashFlow: "Fluxo de Caixa",
    netWorth: "Patrimônio Líquido",
    spendingByCategory: "Despesas de Moradia por Categoria",
    topCategories: "Principais Categorias",
    monthlyComparison: "Comparação Mensal",
    viewAll: "Ver Tudo",
    viewMore: "Ver Mais",
    seeAll: "Ver Tudo",
    welcome: "Bem-vindo, {{name}}",
    quickActions: "Ações Rápidas",
    commonTasks: "Tarefas comuns",
    syncedAccounts: "Contas Sincronizadas",
    connected: "conectadas",
    allCurrent: "todas atualizadas",
    noAccountsConnected: "Nenhuma conta conectada ainda",
    connectMoreAccounts: "Conectar mais contas",
    allConnectedAccounts: "Todas as contas conectadas",
    noTransactionsYet: "Nenhuma transação ainda",
    viewAllTransactions: "Ver todas as transações",
    live: "Ao vivo",
    actionNeeded: "Ação necessária",
  },

  // Gráficos
  charts: {
    period: "Período",
    value: "Valor",
    change: "Variação",
    percentage: "Percentual",
    currency: "Moeda",
    category: "Categoria",
    amount: "Valor",
    date: "Data",
    trend: "Tendência",
    average: "Média",
    total: "Total",
    count: "Contagem",
    min: "Mínimo",
    max: "Máximo",
    distribution: "Distribuição",
    comparison: "Comparação",
  },

  // Tipos de Ativo
  assetTypes: {
    Equity: {
      name: "Ações",
      description: "Ações, ETFs e outros títulos de renda variável"
    },
    Crypto: {
      name: "Cripto",
      description: "Bitcoin, Ethereum e outras criptomoedas"
    },
    RealEstate: {
      name: "Imóveis",
      description: "Imóveis residenciais e comerciais"
    },
    Bonds: {
      name: "Títulos",
      description: "Títulos públicos e privados"
    },
    PensionPlan: {
      name: "Previdência",
      description: "Planos de aposentadoria e previdência"
    },
    Stocks: {
      name: "Ações",
      description: "Ações de empresas individuais"
    },
    Funds: {
      name: "Fundos",
      description: "Fundos mútuos e fundos de investimento"
    },
    ETFs: {
      name: "ETFs",
      description: "Fundos de índice negociados em bolsa"
    },
    Cash: {
      name: "Caixa",
      description: "Caixa e equivalentes de caixa"
    },
    Collectible: {
      name: "Colecionável",
      description: "Arte, colecionáveis e outros itens únicos"
    },
    Vehicle: {
      name: "Veículo",
      description: "Carros, barcos e outros veículos"
    },
    Other: {
      name: "Outro",
      description: "Outros ativos diversos"
    }
  },

  // Tipos e categorias de transação
  transactions: {
    income: "Receita",
    expense: "Despesa",
    transfer: "Transferência",
    investment: "Investimento",
    withdrawal: "Saque",
    deposit: "Depósito",
    payment: "Pagamento",
    refund: "Reembolso",
    fee: "Taxa",
    tax: "Imposto",
    dividend: "Dividendo",
    interest: "Juros",
    sale: "Venda",
    purchase: "Compra",
    other: "Outro",
    // Categorias de transação
    housing: "Moradia",
    food: "Alimentação",
    transportation: "Transporte",
    utilities: "Serviços Públicos",
    healthcare: "Saúde",
    personal: "Pessoal",
    entertainment: "Entretenimento",
    education: "Educação",
    investments: "Investimentos",
    ventures: "Empreendimentos",
  },

  // Financial Summary específico
  financialSummary: {
    revenue: "Receita",
    assetTransfer: "Transferência de Ativo",
    housingUtilities: "Moradia e Serviços",
    livingExpenses: "Despesas de Moradia",
    personalDevelopment: "Desenvolvimento Pessoal",
    investments: "Investimentos",
    housing: "Moradia",
    maintenance: "Manutenção",
    utilities: "Serviços Públicos",
    eatingOut: "Comer Fora",
    eatingIn: "Comer em Casa",
    healthBeauty: "Saúde e Beleza",
    shopping: "Compras",
    entertainment: "Entretenimento",
    travel: "Viagem",
    education: "Educação",
    skills: "Habilidades",
    international: "Internacional",
    domestic: "Nacional",
    laborIncome: "Renda do Trabalho",
    taxes: "Impostos",
    ventures: "Empreendimentos",
    angelInvestments: "Investimento Anjo",
    variableIncome: "Renda Variável",
    gambling: "Apostas",
    margin: "margem",
    netIncome: 'Receita Líquida',
    discretionaryIncome: 'Renda Discricionária',
    savingsCapacity: 'Capacidade de Poupança',
    netSavings: 'Poupança Líquida',
    otherActivity: 'Outra Atividade',
    netInvested: "Investimento líquido",
    netInvestedTooltip: "Dinheiro aplicado em investimentos menos o dinheiro retirado (vendas, resgates). Um valor positivo significa que você investiu mais do que retirou. Não é um ganho nem uma perda.",
    netDebtRepaid: "Dívida líquida amortizada",
    netDebtRepaidTooltip: "Dívida amortizada menos novos empréstimos (por exemplo, um empréstimo depositado pelo seu banco). Um valor positivo significa que você reduziu sua dívida.",
    quarters: {
      q1: "T1",
      q2: "T2",
      q3: "T3",
      q4: "T4",
    },
  },

  // Elementos de UI
  ui: {
    darkMode: "Modo Escuro",
    lightMode: "Modo Claro",
    systemMode: "Modo do Sistema",
    close: "Fechar",
    open: "Abrir",
    collapse: "Recolher",
    expand: "Expandir",
    refresh: "Atualizar",
    retry: "Tentar novamente",
    rename: "Renomear",
    edit: "Editar",
    delete: "Excluir",
    deleting: "Excluindo...",
    cancel: "Cancelar",
    saveChanges: "Salvar Alterações",
    clearFilters: "Limpar Filtros",
    dialog: {
      deleteTitle: "Excluir {{entity}}",
      deleteConfirmation: "Tem certeza de que deseja excluir \"{{name}}\"? Esta ação não pode ser desfeita.",
    },
    entity: {
      category: "Categoria",
      account: "Conta",
    },
    loading: "Carregando...",
    error: "Erro",
    success: "Sucesso",
    warning: "Aviso",
    info: "Informação",
    notification: "Notificação",
    alert: "Alerta",
    dialogElement: "Diálogo",
    modal: "Modal",
    drawer: "Gaveta",
    toast: "Notificação",
    tooltipElement: "Dica",
    badge: "Selo",
    avatar: "Avatar",
    icon: "Ícone",
    button: "Botão",
    input: "Entrada",
    select: "Seleção",
    checkbox: "Caixa de Seleção",
    radio: "Opção",
    toggle: "Alternância",
    slider: "Controle Deslizante",
    range: "Intervalo",
    datepicker: "Seletor de Data",
    timepicker: "Seletor de Hora",
    colorpicker: "Seletor de Cor",
    filepicker: "Seletor de Arquivo",
    pagination: "Paginação",
    table: "Tabela",
    list: "Lista",
    card: "Cartão",
    tabs: "Abas",
    accordion: "Acordeão",
    menu: "Menu",
    dropdown: "Menu Suspenso",
    popover: "Popover",
    breadcrumb: "Caminho de Navegação",
    navigation: "Navegação",
    sidebar: "Barra Lateral",
    header: "Cabeçalho",
    footer: "Rodapé",
    content: "Conteúdo",
    layout: "Layout",
    gridLayout: "Grade",
    column: "Coluna",
    row: "Linha",
    section: "Seção",
    container: "Contêiner",
    wrapper: "Invólucro",
    box: "Caixa",
    flexbox: "Flexbox",
    stack: "Pilha",
    group: "Grupo",
    divider: "Divisor",
    spacer: "Espaçador",
    separator: "Separador",
    spinner: "Carregamento",
    progress: "Progresso",
    skeleton: "Esqueleto",
    placeholder: "Espaço Reservado",
    empty: "Vazio",
    fallback: "Alternativa",
    errorState: "Erro",
    successState: "Sucesso",
    warningState: "Aviso",
    infoState: "Informação",
    across: "Em",
    upgradeToPro: "Assinar o Pro",
    upgradeDescription: "Obtenha insights e recursos avançados",
    upgradeNow: "Assinar agora",
  },

  // Notificações e alertas
  notifications: {
    success: {
      saved: "Salvo com sucesso!",
      created: "Criado com sucesso!",
      updated: "Atualizado com sucesso!",
      deleted: "Excluído com sucesso!",
      imported: "Importado com sucesso!",
      exported: "Exportado com sucesso!",
      uploaded: "Enviado com sucesso!",
      downloaded: "Baixado com sucesso!",
      sent: "Enviado com sucesso!",
      submitted: "Enviado com sucesso!",
    },
    error: {
      title: "Erro",
      general: "Ocorreu um erro. Por favor, tente novamente.",
      generic: "Ocorreu um erro. Por favor, tente novamente.",
      notFound: "Recurso não encontrado.",
      unauthorized: "Acesso não autorizado.",
      forbidden: "Acesso proibido.",
      validation: "Erro de validação. Por favor, verifique seus dados.",
      server: "Erro no servidor. Por favor, tente novamente mais tarde.",
      network: "Erro de rede. Por favor, verifique sua conexão.",
      timeout: "A requisição expirou. Por favor, tente novamente.",
      conflict: "Erro de conflito. O recurso já existe.",
      badRequest: "Requisição inválida. Por favor, verifique seus dados.",
      unavailable: "Serviço indisponível. Por favor, tente novamente mais tarde.",
      tooManyRequests: "Muitas requisições. Por favor, tente novamente mais tarde.",
      deleteCategory: "Falha ao excluir categoria. Por favor, tente novamente.",
    },
    warning: {
      unsavedChanges: "Você tem alterações não salvas. Tem certeza de que deseja sair?",
      deleteConfirmation: "Tem certeza de que deseja excluir este item?",
      limitReached: "Você atingiu o limite.",
      lowBalance: "Seu saldo está baixo.",
      expiringSoon: "Expirando em breve.",
    },
    info: {
      noResults: "Nenhum resultado encontrado.",
      empty: "Nenhum item para exibir.",
      loading: "Carregando...",
      processingRequest: "Processando sua solicitação...",
      newVersion: "Uma nova versão está disponível.",
      comingSoon: "Em breve!",
      maintenance: "Manutenção programada.",
    },
    center: {
      title: "Notificações",
      allCaughtUp: "Tudo em dia",
    },
  },

  accountForm: {
    accountName: "Nome da Conta",
    accountNumber: "Número da Conta",
    bank: "Banco / Instituição",
    owners: "Titulares",
    currency: "Moeda",
    country: "País",
    accountCreated: "Conta criada",
    accountCreatedSuccess: "{{name}} foi adicionada às suas contas.",
    accountUpdated: "Conta atualizada",
    accountUpdatedSuccess: "A conta foi atualizada com sucesso.",
    createAccount: "Criar Conta",
    updateAccount: "Atualizar Conta",
    createError: "Falha ao criar conta. Por favor, tente novamente.",
    updateError: "Falha ao atualizar conta. Por favor, tente novamente.",
    selectBank: "Selecione um banco",
    selectCurrency: "Selecione uma moeda",
    selectCountry: "Selecione um país",
    addBank: "Adicionar novo banco",
    addBankError: "Falha ao adicionar banco. Por favor, tente novamente.",
  },
  addBankDialog: {
    title: "Adicionar novo banco",
    description: "Digite o nome do banco que deseja adicionar.",
    nameLabel: "Nome do banco",
    namePlaceholder: "ex.: Chase, Monzo, Revolut",
    validationError: "O nome do banco deve ter entre 2 e 100 caracteres.",
  },
  categoryForm: {
    name: "Nome da Categoria",
    type: "Tipo",
    group: "Grupo",
    categoryCreated: "Categoria criada",
    categoryCreatedSuccess: "{{name}} foi adicionada às suas categorias.",
    categoryUpdated: "Categoria atualizada",
    categoryUpdatedSuccess: "A categoria foi atualizada com sucesso.",
    createCategory: "Criar Categoria",
    updateCategory: "Atualizar Categoria",
    createError: "Falha ao criar categoria. Por favor, tente novamente.",
    updateError: "Falha ao atualizar categoria. Por favor, tente novamente.",
  },
  transactionForm: {
    date: "Data",
    transactionType: "Tipo de Transação",
    description: "Descrição",
    amount: "Valor",
    fromAccount: "Da Conta",
    account: "Conta",
    toAccount: "Para Conta",
    category: "Categoria",
    notes: "Notas (Opcional)",
    transactionCreated: "Transação criada",
    transactionCreatedSuccess: "Nova transação foi registrada.",
    transactionUpdated: "Transação atualizada",
    transactionUpdatedSuccess: "A transação foi atualizada com sucesso.",
    createTransaction: "Criar Transação",
    updateTransaction: "Atualizar Transação",
    createError: "Falha ao criar transação. Por favor, tente novamente.",
    updateError: "Falha ao atualizar transação. Por favor, tente novamente.",
  },
  userForm: {
    email: "E-mail",
    userCreated: "Usuário criado",
    userCreatedSuccess: "{{email}} foi convidado para sua equipe.",
    userUpdated: "Usuário atualizado",
    userUpdatedSuccess: "O usuário foi atualizado com sucesso.",
    inviteUser: "Convidar Usuário",
    updateUser: "Atualizar Usuário",
    createError: "Falha ao criar usuário. Por favor, tente novamente.",
    updateError: "Falha ao atualizar usuário. Por favor, tente novamente.",
  },

  // Traduções de categorias padrão (chaveado por defaultCategoryCode)
  defaultCategories: {
    names: {
      OPERATING_CASH: "Caixa Operacional",
      STOCKS: "Ações",
      INVESTMENT_FUNDS: "Fundos",
      ETFS: "ETFs",
      COPY_TRADING: "Copy Trading",
      PENSION_PLAN: "Previdência",
      GOVERNMENT_BONDS: "Títulos Públicos",
      CORPORATE_BONDS: "Títulos Privados",
      CRYPTO: "Cripto",
      REAL_ESTATE: "Imóveis",
      COLLECTIBLE: "Colecionável",
      VEHICLE: "Veículo",
      COMMODITIES: "Commodities",
      PRIVATE_EQUITY: "Private Equity",
      MORTGAGE: "Financiamento Imobiliário",
      CREDIT_CARD_DEBT: "Dívida de Cartão de Crédito",
      ALLOWANCE: "Mesada",
      RENT_INCOME: "Renda de Aluguel",
      SALARY: "Salário",
      FREELANCE_INCOME: "Rendimento de Freelance",
      BONUS: "Bônus",
      COMMISSION: "Comissão",
      GOVERNMENT_WELFARE: "Benefícios do Governo",
      TAXES: "Impostos",
      TAX_REFUND: "Restituição de Impostos",
      DIVIDENDS: "Dividendos",
      BOND_INCOME: "Renda de Títulos",
      INTEREST_INCOME: "Renda de Juros",
      OPTIONS_INCOME: "Renda de Opções",
      RENT: "Aluguel",
      HOA_COMMUNITY_FEES: "Taxa de Condomínio",
      SECURITY_DEPOSIT: "Caução",
      HOME_INSURANCE: "Seguro Residencial",
      POWER_AND_GAS: "Energia e Gás",
      WATER: "Água",
      DATA_PLAN: "Plano de Dados",
      INTERNET: "Internet",
      CLEANING_SERVICE: "Serviço de Limpeza",
      HOME_IMPROVEMENT: "Reforma da Casa",
      GROCERIES: "Supermercado",
      CONVENIENCE_STORES: "Lojas de Conveniência",
      DOCTOR: "Médico",
      HEALTH_INSURANCE: "Plano de Saúde",
      PHARMACY: "Farmácia",
      BIKING: "Bicicleta",
      FUEL_AND_GAS: "Combustível",
      VEHICLE_MAINTENANCE: "Manutenção do Veículo",
      VEHICLE_TAXES_AND_TICKETS: "IPVA e Multas",
      VEHICLE_INSURANCE: "Seguro do Veículo",
      METRO: "Metrô",
      PARKING: "Estacionamento",
      TAXI: "Táxi",
      TRAINS: "Trem",
      BUS: "Ônibus",
      PET_CARE: "Cuidados com Pet",
      PET_FOOD: "Ração",
      PET_INSURANCE: "Seguro Pet",
      BANKING_FEES: "Taxas Bancárias",
      DOCUMENTATION: "Documentação",
      NOTARY: "Cartório",
      ACCOUNTING: "Contabilidade",
      BUSINESS_MEAL: "Refeição de Negócios",
      RESTAURANTS: "Restaurantes",
      BAKERY_AND_COFFEE: "Padaria e Café",
      FOOD_DELIVERY: "Delivery de Comida",
      BAR: "Bar",
      NIGHTCLUB: "Balada",
      CONCERTS: "Shows",
      MOVIES_AND_THEATER: "Cinema e Teatro",
      OUTDOOR_ACTIVITIES: "Atividades ao Ar Livre",
      SPORTING_EVENTS: "Eventos Esportivos",
      GAMBLING: "Apostas",
      GAMING: "Games",
      BEAUTY: "Beleza",
      HAIRCARE: "Cabelo",
      SPORTS_AND_GYM: "Esportes e Academia",
      SHOPPING: "Compras",
      ELECTRONICS: "Eletrônicos",
      FURNITURE_AND_DIY: "Móveis e Faça Você Mesmo",
      CLOTHES_AND_FASHION: "Roupas e Moda",
      GIFTS: "Presentes",
      JEWELRY: "Joias",
      DECORATION_AND_TEXTILES: "Decoração e Têxteis",
      KITCHENWARE: "Utensílios de Cozinha",
      SOFTWARE: "Software",
      CONTENT_AND_MEDIA: "Conteúdo e Mídia",
      LOYALTY_PROGRAMS: "Programas de Fidelidade",
      CASH_AT_ATM: "Saque no Caixa Eletrônico",
      INHERITANCE: "Herança",
      RECEIVED_DOMESTIC: "Transferência Recebida — Nacional",
      RECEIVED_INTERNATIONAL: "Transferência Recebida — Internacional",
      SENT_DOMESTIC: "Transferência Enviada — Nacional",
      SENT_INTERNATIONAL: "Transferência Enviada — Internacional",
      BIZ_SALES_REVENUE: "Receita de Vendas",
      BIZ_SERVICE_REVENUE: "Receita de Serviços",
      BIZ_REFERRAL_INCOME: "Indicação e Afiliados",
      BIZ_INVENTORY: "Estoque e Materiais",
      BIZ_SHIPPING: "Frete e Logística",
      BIZ_SAAS: "SaaS e Ferramentas",
      BIZ_CLOUD: "Cloud e Hospedagem",
      BIZ_MARKETING: "Marketing e Publicidade",
      BIZ_DATA_SERVICES: "Dados e Serviços de API",
      BIZ_OFFICE: "Escritório e Espaço",
      BIZ_DOMAINS: "Domínios e Licenças",
      BIZ_EQUIPMENT: "Equipamentos Empresariais",
      BIZ_OTHER_COSTS: "Outros Custos Empresariais",
      BIZ_FREELANCERS: "Freelancer e Prestador",
      BIZ_PROFESSIONAL_SERVICES: "Serviços Profissionais",
      BIZ_TAXES: "Impostos e Taxas Empresariais",
      BIZ_CAPITAL: "Aporte de Capital",
      MUSIC: "Instrumentos Musicais",
      THERAPY_AND_COUNSELING: "Terapia e Aconselhamento",
      MENTORING: "Coaching e Mentoria",
      SCHOOL: "Escola",
      ONLINE_COURSES: "Curso Online",
      TRAVEL_TRANSPORT: "Transporte de Viagem",
      ACCOMMODATION: "Hospedagem",
      CAR_RENTAL: "Aluguel de Carro",
      TOURS_AND_ACTIVITIES: "Passeios e Atividades",
      TRAVEL_EXPENSES: "Despesas de Viagem",
      DONATIONS: "Doações",
      BOOKS: "Livros",
    },
    descriptions: {
      SENT_DOMESTIC: "Dinheiro enviado a alguém dentro do seu país — devoluções a amigos, transferências entre suas próprias contas, ou qualquer débito não relacionado a compra.",
      SENT_INTERNATIONAL: "Dinheiro enviado para o exterior — transferências para família, para suas próprias contas no exterior, ou qualquer débito transfronteiriço não relacionado a compra.",
      RECEIVED_DOMESTIC: "Dinheiro recebido de alguém dentro do seu país — devoluções de amigos, transferências entre suas próprias contas, ou outros créditos que não sejam renda.",
      RECEIVED_INTERNATIONAL: "Dinheiro recebido do exterior — presentes de família, transferências de suas próprias contas no exterior, ou outros créditos transfronteiriços que não sejam renda.",
      BIZ_SERVICE_REVENUE: "Receita de serviços prestados pelo seu próprio negócio ou projeto paralelo. Se o trabalho freelance é sua atividade principal e não um negócio paralelo, use Rendimento de Freelance (em Rendimento do Trabalho).",
      BIZ_SALES_REVENUE: "Receita de vendas de bens pelo seu próprio negócio ou projeto paralelo.",
      BIZ_OTHER_REVENUE: "Outras fontes de receita do seu próprio negócio ou projeto paralelo — licenciamentos, royalties, pagamentos de parceiros, etc.",
      ALLOWANCE: "Mesada, dinheiro de bolso ou apoio familiar contínuo. Útil para estudantes e implementações do Bliss em escolas onde os usuários registram dinheiro recebido de familiares.",
      GOVERNMENT_WELFARE: "Transferências do governo — seguro-desemprego, benefícios infantis, previdência social ou similares. Não são rendimentos do trabalho.",
      INHERITANCE: "Dinheiro ou bens herdados de um familiar falecido. Classificado em Transferências por ser um valor único e irregular, não um rendimento de trabalho ou investimento — mantê-lo aqui evita distorcer as tendências anuais de renda.",
      FREELANCE_INCOME: "Rendimento de trabalho freelance ou consultoria tratado como sua atividade principal. Se o trabalho é um negócio paralelo com contabilidade própria, use Receita de Serviços (em Empresas).",
      BONUS: "Bônus anuais, trimestrais ou pontuais pagos pelo empregador. Frequentemente tributados de forma diferente do salário regular — separá-lo facilita a leitura das tendências de renda.",
      COMMISSION: "Comissões de vendas ou outra remuneração por desempenho atrelada à receita que você gerou.",
      TAX_REFUND: "Restituição recebida da autoridade tributária por pagamento a maior em período anterior.",
    },
    groups: {
      Cash: "Caixa",
      Stocks: "Ações",
      Funds: "Fundos",
      ETFs: "ETFs",
      "Pension Plan": "Previdência",
      Bonds: "Títulos",
      Crypto: "Cripto",
      "Real Estate": "Imóveis",
      Collectible: "Colecionável",
      "Depreciating assets": "Ativos depreciáveis",
      Commodities: "Commodities",
      "Private Equity": "Private Equity",
      "Real Estate Loan": "Financiamento Imobiliário",
      "Personal Debt": "Dívida Pessoal",
      "Passive Income": "Renda Passiva",
      "Labor Income": "Renda do Trabalho",
      Taxes: "Impostos",
      Housing: "Moradia",
      Utilities: "Serviços Públicos",
      "Home Maintenance": "Manutenção da Casa",
      "Eating In": "Comer em Casa",
      Healthcare: "Saúde",
      Transportation: "Transporte",
      Pets: "Pets",
      Finance: "Finanças",
      Civil: "Civil",
      "Dining Out": "Comer Fora",
      Entertainment: "Entretenimento",
      "Wellness & Beauty": "Bem-estar e Beleza",
      "Shopping & Gifts": "Compras e Presentes",
      Subscriptions: "Assinaturas",
      Misc: "Diversos",
      Inheritance: "Herança",
      Domestic: "Nacional",
      International: "Internacional",
      Revenue: "Receita",
      "Cost of Goods Sold": "Custo de Mercadorias Vendidas",
      "Operating Expenses": "Despesas Operacionais",
      "People & Services": "Pessoas e Serviços",
      Capital: "Capital",
      Skills: "Habilidades",
      "Mental Health": "Saúde Mental",
      Education: "Educação",
      Travel: "Viagem",
      Donations: "Doações",
      Other: "Outro",
      Others: "Outros",
      "N/A": "N/D",
    },
    types: {
      Income: "Receita",
      Essentials: "Essenciais",
      Lifestyle: "Estilo de Vida",
      Growth: "Crescimento",
      Ventures: "Empreendimentos",
      Investments: "Investimentos",
      Asset: "Ativo",
      Debt: "Dívida",
      Transfers: "Transferências",
    },
    processingHints: {
      API_STOCK: "API de Preços de Ações",
      API_CRYPTO: "API de Preços de Cripto",
      API_FUND: "API de Preços de Fundos",
      AMORTIZING_LOAN: "Acompanhamento de Empréstimo",
      SIMPLE_LIABILITY: "Acompanhamento de Passivo",
      CASH: "Acompanhamento de Caixa",
      MANUAL: "Manual",
      TAX_DEDUCTIBLE: "Dedutível de Imposto",
      DEBT: "Acompanhamento de Dívida",
      COPY_TRADING: "Copy Trading do eToro",
    },
  },

  // Página de contas
  accountsPage: {
    title: "Contas",
    subtitle: "Gerencie suas conexões bancárias e contas manuais.",
    connectBank: "Conectar Conta Bancária",
    addManual: "Adicionar Conta Manual",
    selectAccount: "Selecione uma conta",
    selectAccountHint: "Escolha uma conta da lista para ver detalhes da conexão, registros de sincronização e ações de gerenciamento.",
    deleteTitle: "Excluir Conta",
    deleteConfirm: "Tem certeza de que deseja excluir \"{{name}}\"? Esta ação não pode ser desfeita.",
    deleteSuccess: "Conta excluída",
    deleteSuccessDetail: "{{name}} foi removida.",
    deleteFailed: "Falha ao excluir conta",
    deleteAction: "Excluir conta",
    dangerZone: "Zona de perigo",
    deleteBlockedTransactions_one: "Esta conta tem {{count}} transação vinculada e não pode ser excluída até que ela seja removida ou reatribuída a outra conta.",
    deleteBlockedTransactions_other: "Esta conta tem {{count}} transações vinculadas e não pode ser excluída até que elas sejam removidas ou reatribuídas a outra conta.",
    deleteBlockedTransactions: "Esta conta tem {{count}} transações vinculadas e não pode ser excluída até que elas sejam removidas ou reatribuídas a outra conta.",
    deleteBlockedPlaid: "Esta conta ainda está conectada ao seu banco. Desconecte a conexão bancária primeiro e depois exclua a conta.",
    deleteBlockedPlaidHint: "Desconecte esta conexão bancária primeiro (use \"Pausar sincronização\" acima) antes de excluir a conta.",
    deleteUnknownError: "Não foi possível excluir esta conta. Tente novamente.",
    searchAccounts: "Buscar contas...",
    noAccountsMatch: "Nenhuma conta corresponde à sua busca.",
    noAccountsYet: "Nenhuma conta ainda.",
    synced: "Sincronizada",
    actionRequired: "Ação Necessária",
    disconnected: "Desconectada",
    manual: "Manual",
  },

  // Painel de detalhes da conta
  accountDetail: {
    edit: "Editar",
    plaidConnected: "Plaid Conectado",
    placeholderNumberHint: "Esta conta ainda tem um número provisório da configuração.",
    addAccountNumber: "Adicionar o número de conta real",
    connectionHealth: "Saúde da Conexão",
    consentExpired: "Consentimento expirado",
    consentExpiringSoon: "Consentimento expirando em breve",
    consentExpiredOn: "Seu consentimento bancário expirou em {{date}}. Reconecte para retomar a sincronização.",
    consentExpiresOn: "Seu consentimento bancário expira em {{date}} ({{days}} dia restante). Reconecte antes para evitar interrupção.",
    consentExpiresOnPlural: "Seu consentimento bancário expira em {{date}} ({{days}} dias restantes). Reconecte antes para evitar interrupção.",
    reconnect: "Reconectar",
    disconnectedMessage: "Esta conexão bancária foi desconectada. Vincule novamente para retomar a sincronização de transações.",
    reconnectBank: "Reconectar Banco",
    actions: "Ações",
    resyncNow: "Sincronizar Agora",
    rotateToken: "Rotacionar Token",
    relinkPlaid: "Revincular Plaid",
    pauseSync: "Pausar Sincronização",
    security: "Segurança",
    securityEncryption: "Todos os dados da conta são criptografados em repouso usando AES-256-GCM.",
    securityTokens: "Os tokens de acesso do Plaid são rotacionados periodicamente e armazenados criptografados.",
    pauseSyncDescription: "Isso pausará a sincronização desta conta. Suas transações existentes e histórico de conexão não serão afetados. Você pode reconectar a qualquer momento para retomar.",
    disconnect: "Desconectar",
    disconnecting: "Desconectando...",
    syncTriggered: "Sincronização iniciada",
    syncTriggeredDetail: "Uma nova sincronização foi iniciada para esta conta.",
    syncFailed: "Falha ao iniciar sincronização",
    tokenRotated: "Token rotacionado",
    tokenRotatedDetail: "O token de acesso foi rotacionado com sucesso.",
    tokenRotateFailed: "Falha ao rotacionar token",
    disconnected: "Desconectada",
    disconnectedDetail: "A conexão bancária foi removida.",
    disconnectFailed: "Falha ao desconectar",
    securityDesc: "Todos os dados da conta são criptografados em repouso usando AES-256-GCM.",
    securityPlaid: "Os tokens de acesso do Plaid são rotacionados periodicamente e armazenados criptografados.",
    syncTriggeredDesc: "Uma nova sincronização foi iniciada para esta conta.",
    tokenRotatedDesc: "O token de acesso foi rotacionado com sucesso.",
    disconnectedDesc: "A conexão bancária foi removida.",
    reconnectDesc: "Esta conexão bancária foi desconectada. Vincule novamente para retomar a sincronização de transações.",
    pauseSyncTitle: "Pausar Sincronização",
    pauseSyncDesc: "Isso pausará a sincronização desta conta. Suas transações existentes e histórico de conexão não serão afetados. Você pode reconectar a qualquer momento para retomar.",
    consentExpiredDesc: "Seu consentimento bancário expirou em {{date}}. Reconecte para retomar a sincronização.",
    consentExpiringSoonDesc: "Seu consentimento bancário expira em {{date}} ({{days}} dias restantes). Reconecte antes para evitar interrupção.",
  },

  // Modal de adicionar/editar conta
  accountModal: {
    editTitle: "Editar Conta",
    addTitle: "Adicionar Conta Manual",
    editDescription: "Atualize os detalhes da sua conta.",
    addDescription: "Adicione uma nova conta rastreada manualmente.",
  },

  // Saúde da conexão
  connectionHealth: {
    status: "Status",
    lastSynced: "Última Sincronização",
    nextSync: "Próxima Sincronização",
    approxInterval: "~6 horas",
    historyRange: "Intervalo do Histórico",
    notYetSynced: "Ainda não sincronizado",
    historyStatus: "Status do Histórico",
    complete: "Completo",
    syncingHistory: "Sincronizando histórico completo...",
    institutionId: "ID da Instituição",
    connection: "Conexão",
    manualEntry: "Entrada Manual",
    fetchOlder: "Buscar transações antigas",
    selectStartDate: "Selecione uma data inicial (até 2 anos atrás)",
    fetchFrom: "Buscar a partir de",
    selectDate: "Selecione uma data",
    title: "Saúde da Conexão",
    backfillStarted: "Busca retroativa iniciada",
    backfillDetail: "Buscando transações a partir de {{date}}. Isso pode levar um momento.",
    backfillFailed: "Falha ao iniciar busca retroativa",
    nextSyncValue: "~6 horas",
    fetching: "Buscando...",
    never: "Nunca",
    justNow: "Agora mesmo",
    minutesAgo: "{{count}}min atrás",
    hoursAgo: "{{count}}h atrás",
    daysAgo: "{{count}}d atrás",
    today: "Hoje",
    fetchOlderTransactions: "Buscar transações antigas",
  },

  // Página de revisão de transações
  review: {
    confident: "Confiante",
    newMerchant: "Novo estabelecimento",
    actionNeeded: "Ação necessária",
    uncertain: "Incerto",
    duplicate: "Duplicada",
    possibleDup: "Possível duplicata",
    approveAll: "Aprovar Tudo",
    date: "Data",
    merchant: "Estabelecimento",
    account: "Conta",
    amount: "Valor",
    confidence: "Conf.",
    status: "Status",
    actions: "Ações",
    uncategorized: "Sem categoria",
    required: "Obrigatório",
    selectAccount: "Selecione uma conta",
    noAccount: "Sem conta",
    investmentEnrichmentRequired: "O enriquecimento de investimento é necessário para esta categoria. Preencha ticker, quantidade e preço.",
    investmentEnrichmentRequiredTickerOptional: "O enriquecimento de investimento é necessário para esta categoria. Preencha quantidade e preço; o ticker é opcional para fundos não listados.",
    currencyMismatch: "Este ativo é negociado em {{assetCurrency}}, mas a transação está em {{txCurrency}}. Os valores da carteira podem precisar de conversão de moeda.",
    detailsNotes: "Detalhes / Notas",
    optionalNotes: "Substituição de notas opcional",
    tags: "Etiquetas",
    skip: "Pular",
    merchantHistory: "Histórico do Estabelecimento",
    noMerchantHistory: "Nenhuma transação anterior encontrada para este estabelecimento.",
    blissAnalysis: "Análise Bliss",
    aiConfidence: "Confiança da IA",
    source: "Origem",
    plaidCategory: "Categoria Plaid",
    classificationReasoning: "Raciocínio da Classificação",
    whyChose: "Por que escolhi esta",
    sourceLabels: {
      USER_OVERRIDE: "Definido por você",
      EXACT_MATCH: "Correspondência do histórico",
      VECTOR_MATCH: "Semelhante ao seu histórico",
      VECTOR_MATCH_GLOBAL: "Correspondência da comunidade",
      LLM: "Classificação por IA",
      PLAID_HINT: "Sugerido pelo banco",
      default: "Análise da IA",
    },
    enrichmentRequired: "Enriquecimento Necessário",
    enrichmentDescription: "Esta transação parece ser relacionada a investimento. Forneça os detalhes abaixo para rastreá-la corretamente na sua carteira.",
    tickerSymbol: "Símbolo do Ticker",
    tickerOptional: "opcional",
    tickerPlaceholder: "ex: VWCE, AAPL",
    pricePerShare: "Preço por Ação",
    pricePlaceholder: "ex: 43,67",
    quantity: "Quantidade",
    quantityAuto: "(auto)",
    quantityCalculated: "Calculado automaticamente",
    quantityPlaceholder: "ex: 1,23",
    notesPlaceholder: "Notas opcionais (substitui a descrição padrão da transação)",
    selectCategory: "Por favor, selecione uma categoria",
    selectDate: "Por favor, selecione uma data",
    descriptionRequired: "A descrição é obrigatória",
    selectCurrency: "Por favor, selecione uma moeda",
    selectAccountValidation: "Por favor, selecione uma conta",
    // Strings de nível de página
    pageTitle: "Revisão de Transações",
    pageSubtitle: "Revise e aprove transações pendentes de todas as fontes.",
    requeueSkipped: "Reenfileirar Puladas",
    bulkPromote: "Promoção em Massa",
    reviewedProgress: "{{done}} de {{total}} revisadas",
    allPending: "Todas Pendentes",
    fromPlaid: "Do Plaid",
    fromImports: "De Importações",
    allCaughtUp: "Tudo em dia!",
    noPendingTransactions: "Nenhuma transação pendente para revisar.",
    plaidTransactions: "Transações do Plaid",
    importTransactions: "Transações de Importação",
    pending: "pendente",
    cancelImport: "Cancelar importação",
    noPlaidToReview: "Nenhuma transação do Plaid para revisar",
    allPlaidProcessed: "Todas as transações do Plaid foram processadas.",
    noPendingImports: "Nenhuma importação pendente",
    allImportsCommitted: "Todas as importações foram consolidadas.",
    committingTransactions: "Consolidando Transações...",
    complete: "completo",
    noRowsInImport: "Nenhuma linha nesta importação.",
    committing: "Consolidando...",
    commitAll: "Consolidar Tudo",
    // Gaveta de detalhes
    selectCategoryPlaceholder: "Selecione uma categoria",
    saveChanges: "Salvar Alterações",
    saveAndPromote: "Salvar e Promover",
    resetToPending: "Voltar para Pendente",
    resetToPendingDesc: "Move esta linha de volta para pendente para que não seja confirmada automaticamente. Útil para desfazer uma classificação auto-promovida que você quer revisar.",
    // Diálogo de promoção em massa
    bulkPromoteTitle: "Promoção em Massa de Transações",
    bulkPromoteDescription: "Promova automaticamente todas as transações classificadas do Plaid que excedam o limite de confiança.",
    minConfidenceThreshold: "Limite Mínimo de Confiança",
    threshold90: "90% (Mais conservador)",
    threshold80: "80% (Recomendado)",
    threshold70: "70%",
    threshold50: "50% (Menos conservador)",
    thresholdHint: "Apenas transações com confiança da IA igual ou acima deste limite serão promovidas.",
    promoteAll: "Promover Tudo",
    promoting: "Promovendo...",
    // Diálogo de promoção por descrição
    promoteMatchingTitle: "Promover transações correspondentes?",
    promoteMatchingDescription: "Encontradas <strong>{{count}} transação(ões) pendente(s)</strong> com o nome \"{{description}}\".",
    justThisOne: "Apenas esta",
    promoteAllCount: "Promover todas {{count}}",
    // Diálogo de confirmação na gaveta
    confirmMatchingTitle: "Confirmar transações correspondentes também?",
    confirmMatchingDescription: "{{verb}} <strong>{{count}} outra(s) transação(ões) pendente(s)</strong> com o nome \"{{description}}\". Confirmar todas como <strong>{{category}}</strong>?",
    confirmAllCount: "Confirmar todas {{count}}",
    confirming: "Confirmando...",
    // Paginação
    pageOf: "Página {{current}} de {{total}}",
    // Labels de origem (adicional)
    unknown: "Desconhecido",
    // Falha de classificação e nova tentativa
    classificationFailed: "Falha na classificação",
    retryClassification: "Repetir classificação",
    failedTransactionsBanner: "{{count}} transação(ões) com falha na classificação",
    retrySuccess: "Nova tentativa iniciada",
    retryError: "Falha ao iniciar nova tentativa",
    errorTimedOut: "A classificação por IA excedeu o tempo limite — tente novamente ou categorize manualmente",
    errorRateLimited: "Limite de requisições do provedor de IA atingido — tente novamente em breve",
    errorGeneric: "A classificação por IA falhou — tente novamente ou categorize manualmente",
    // Smart Import hold-back reasons (#142)
    holdBack: {
      missingFields: "Falta {{fields}}",
      fieldTicker: "ticker",
      fieldQuantity: "quantidade",
      fieldPrice: "preço",
      missingAccount: "Falta a conta",
      duplicate: "Duplicada",
      updateFailed: "Falha ao atualizar",
      commitError: "Erro ao confirmar",
      filterLabel: "Só retidas",
    },
    commitToast: {
      committedTitle: "Importação confirmada",
      partialTitle: "Confirmação parcial concluída",
      created: "{{count}} criadas",
      updated: "{{count}} atualizadas",
      noneCommitted: "Nenhuma linha confirmada",
      heldBack: "{{count}} retidas: {{reasons}}",
      missingTicker_one: "{{count}} sem ticker",
      missingTicker_other: "{{count}} sem ticker",
      missingQuantity_one: "{{count}} sem quantidade",
      missingQuantity_other: "{{count}} sem quantidade",
      missingPrice_one: "{{count}} sem preço",
      missingPrice_other: "{{count}} sem preço",
      missingAccount_one: "{{count}} sem conta",
      missingAccount_other: "{{count}} sem conta",
      duplicate_one: "{{count}} duplicada",
      duplicate_other: "{{count}} duplicadas",
      updateFailed_one: "{{count}} atualização com falha",
      updateFailed_other: "{{count}} atualizações com falha",
      commitError_one: "{{count}} erro ao confirmar",
      commitError_other: "{{count}} erros ao confirmar",
      stillToReview: "{{count}} ainda para revisar",
      done: "Pronto.",
    },
  },

  // Página de taxas de câmbio
  currencyRates: {
    title: "Taxas de Câmbio",
    subtitle: "Gerencie taxas de câmbio para cálculos financeiros",
    refreshRates: "Atualizar Taxas",
    addRate: "Adicionar Taxa",
    searchPlaceholder: "Buscar moedas ou provedores...",
    from: "De",
    to: "Para",
    rate: "Taxa",
    year: "Ano",
    month: "Mês",
    day: "Dia",
    provider: "Provedor",
    lastUpdated: "Última Atualização",
    noRatesFound: "Nenhuma taxa encontrada",
    addTitle: "Adicionar Taxa de Câmbio",
    providerOptional: "Provedor (opcional)",
    adding: "Adicionando...",
  },

  // Página de gerenciamento de usuários
  userManagement: {
    title: "Gerenciamento de Usuários",
    subtitle: "Gerencie usuários e seu acesso ao seu espaço",
    createUser: "Criar Usuário",
    createTitle: "Criar um Novo Usuário",
    createDescription: "Crie uma nova conta de usuário com credenciais de login.",
    editTitle: "Editar Usuário",
    editDescription: "Atualize informações e permissões de acesso do usuário",
    name: "Nome",
    namePlaceholder: "Digite o nome",
    emailAddress: "Endereço de E-mail",
    emailPlaceholder: "Digite o endereço de e-mail",
    password: "Senha",
    passwordPlaceholder: "Defina uma senha (mín. 6 caracteres)",
    role: "Função",
    selectRole: "Selecione a função",
    roleAdmin: "Administrador",
    roleMember: "Membro",
    roleViewer: "Visualizador (somente leitura)",
    preferredLanguage: "Idioma Preferido",
    selectLanguage: "Selecione o idioma",
    birthDate: "Data de Nascimento",
    cancel: "Cancelar",
    updateUser: "Atualizar Usuário",
    tenantUsers: "Usuários do Espaço",
    tenantUsersDescription: "Gerencie os usuários com acesso aos seus dados financeiros",
    searchUsers: "Buscar usuários...",
    statusFilter: "Status",
    allStatuses: "Todos os Status",
    statusActive: "Ativo",
    statusPending: "Pendente",
    statusInactive: "Inativo",
    showing: "Exibindo",
    of: "de",
    users: "usuários",
    user: "Usuário",
    lastLogin: "Último Acesso",
    never: "Nunca",
    editUser: "Editar usuário",
    resendInvitation: "Reenviar convite",
    removeUser: "Remover usuário",
    noUsersFound: "Nenhum usuário encontrado com os filtros aplicados",
    userCreated: "Usuário criado",
    userCreatedDetail: "{{name}} foi criado com sucesso",
    userCreateFailed: "Ocorreu um erro ao criar o usuário",
    userUpdated: "Usuário atualizado",
    userUpdatedDetail: "{{name}} foi atualizado com sucesso",
    userUpdateFailed: "Ocorreu um erro ao atualizar o usuário",
    userRemoved: "Usuário removido",
    userRemovedDetail: "O usuário foi removido deste espaço",
    userRemoveFailed: "Ocorreu um erro ao remover o usuário",
    invitationSent: "Convite enviado",
    invitationSentDetail: "Um novo convite foi enviado para {{email}}",
    invitationFailed: "Ocorreu um erro ao reenviar o convite",
    relationSelf: "Eu mesmo",
    relationPartner: "Cônjuge",
    relationChild: "Filho(a)",
    relationRelative: "Outro Parente",
    relationFriend: "Amigo(a)",
    relationColleague: "Colega",
    relationOther: "Outro",
  },

  // Página de análise de ações
  equityAnalysis: {
    diversified: "Diversificado",
    etfBadge: "ETF",
    basedOn: "com base em {{pct}}% do valor",
    unmapped: "{{pct}}% não identificado",
    copyBadge: "Cópia",
    viaCopy: "via @{{username}}",
    viaCopyIncluded: "inclui {{value}} via @{{username}}",
    copyCash: "Caixa",
    copyUnmapped: "Não identificado",
    copySplit: "{{value}} dividido em {{count}} posições",
    title: "Análise de Ações",
    subtitle: "Analise seus investimentos por setor, indústria, país e classe de ativo",
    totalEquityValue: "Valor Total em Ações",
    holdings: "Posições",
    avgPE: "P/L Médio",
    avgDividendYield: "Dividend Yield Médio",
    groupBy: "Agrupar por:",
    sector: "Setor",
    industry: "Indústria",
    country: "País",
    allocationBy: "Alocação por {{grouping}}",
    noStockHoldings: "Nenhuma posição em ações ou ETFs encontrada",
    top10: "Top 10 Posições por Peso",
    allHoldings: "Todas as Posições em Ações e ETFs",
    noHoldingsHint: "Nenhuma posição encontrada. Adicione ações ou ETFs à sua carteira para ver a análise.",
    symbol: "Símbolo",
    name: "Nome",
    pe: "P/L",
    divYield: "Dividend Yield",
    eps: "LPA",
    weekRange: "Faixa 52S",
    weight: "Peso",
    value: "Valor",
    loadFailed: "Falha ao carregar dados de análise de ações.",
    assetClass: "Classe de ativo",
    lookThrough: "Detalhar ETFs",
    lookThroughHint: "Distribui cada ETF pelos setores e países que ele detém",
    lookThroughWithCopies: "Detalhar ETFs e cópias",
    lookThroughHintWithCopies: "Distribui cada ETF pelos setores e países que ele detém e mostra cada cópia do eToro como as posições em que investe",
    pendingSecurityData: "Aguardando os dados do ativo para {{symbols}}. Estes fundos aparecem aqui assim que forem obtidos.",
    lookThroughOther: "Outros",
    fixedIncomeBucket: "Renda fixa",
    editAssetClass: "Editar a classe de ativo de {{symbol}}",
    automatic: "Automática ({{assetClass}})",
    overrideSaved: "Classe de ativo atualizada",
    overrideFailed: "Não foi possível atualizar a classe de ativo",
    overrideHint: "Definida manualmente",
    etfBreakdown: "Principais setores",
    save: "Salvar",
    cancel: "Cancelar",
    assetClasses: {
      STOCK: "Ação",
      INDEX_ETF: "ETF de índice",
      SECTOR_ETF: "ETF setorial",
      BOND_ETF: "ETF de renda fixa",
      REIT: "FII / REIT",
      FUND: "Fundo",
      GOV_BOND: "Título público",
      CORP_BOND: "Título privado",
      REAL_ESTATE: "Imóvel",
      CRYPTO: "Cripto",
      CASH: "Caixa",
      OTHER: "Outro",
      COPY_TRADE: "Copy trading",
    },
  },

  // Página não encontrada
  notFoundPage: {
    code: "404",
    message: "Ops! Página não encontrada.",
    returnHome: "Voltar para a Página Inicial",
  },

  // Plaid connect
  plaidConnect: {
    success: "Sucesso",
    bankReauthenticated: "Conexão bancária reautenticada com sucesso.",
    reauthFailed: "Reautenticação foi bem-sucedida, mas falhou ao atualizar o status.",
    exchangeFailed: "Falha na troca",
    connectFailed: "Falha ao conectar conta bancária.",
    reconnect: "Reconectar",
    connectBank: "Conectar Banco",
  },

  // Modal de seleção de conta
  accountSelection: {
    loadFailed: "Falha ao carregar contas do banco.",
    allAccountTypes: "Todos os tipos de conta",
    createNew: "Criar nova",
    createNewAccount: "Criar nova conta",
    linkToExisting: "Vincular a existente",
    selectOrCreate: "Selecionar ou criar",
    accountNames: "Nomes das contas",
    accountMappings: "Mapeamento de contas",
    unsupportedCurrencies: "Moedas não suportadas",
    unsupportedCountry: "País não suportado",
    seedInterview: "Entrevista inicial",
    allCategories: "Todas as categorias",
    fetchFailed: "Falha ao buscar contas do Plaid",
    setupTitle: "Configurar Contas",
    syncingTitle: "Sincronização em Progresso...",
    quickClassify: "Classificação Rápida",
    syncComplete: "Sincronização Completa",
    setupDescription: "Escolha contas para sincronizar, vincule a existentes e defina nomes.",
    syncingDescription: "Suas transações estão sendo sincronizadas e classificadas pela IA.",
    seedDescription: "Encontramos suas transações mais recorrentes. Confirme ou ajuste suas categorias para tornar a IA mais inteligente na próxima sincronização.",
    doneDescription: "Todas as transações foram sincronizadas e classificadas.",
    newCurrenciesDetected: "Novas moedas detectadas",
    currenciesUse: "Estas contas utilizam",
    currenciesNotConfigured: "que {{plurality}} ainda não estão no seu espaço. Elas serão adicionadas automaticamente quando você sincronizar.",
    newCountryDetected: "Novo país detectado",
    bankOperatesIn: "Este banco opera em",
    countryNotConfigured: "que ainda não está no seu espaço. Ele será adicionado automaticamente quando você sincronizar.",
    notConfigured: "não configurado",
    accountNamePlaceholder: "Nome da conta",
    existingAccountKept: "O nome da conta existente será mantido",
    noAccountsFound: "Nenhuma conta encontrada.",
    syncHistoryNote: "O Bliss sincronizará até 2 anos de histórico. Transações recentes aparecem em segundos; o histórico completo chega em até 24 horas.",
    syncAccounts: "Sincronizar {{count}} Contas",
    accountsLinked: "Contas vinculadas",
    syncingTransactions: "Sincronizando transações",
    aiClassifying: "IA classificando",
    importingTransactions: "Importando suas transações recentes",
    importingFrom: "de",
    fullHistoryNote: "Seu histórico completo de 2 anos continuará sincronizando em segundo plano.",
    promoted: "Promovida",
    pendingReview: "Pendente de Revisão",
    processing: "Processando",
    doNotClose: "Por favor, não feche esta janela enquanto a sincronização estiver em andamento.",
    skipForNow: "Pular por enquanto",
    confirmContinue: "Confirmar e Continuar",
    seedSaveFailed: "Não foi possível salvar as seleções de categoria.",
    historyRange: "Intervalo do Histórico",
    readyForReview: "Pronto para Revisão",
    skippedDuplicates: "Puladas (duplicatas)",
    fullHistorySyncing: "Histórico completo sincronizando em segundo plano",
    currentlySyncedFrom: "Sincronizado atualmente a partir de",
    fullHistoryDetail: "O Bliss sincronizará automaticamente até 2 anos de histórico de transações nas próximas 24 horas. Novas transações aparecerão na sua fila de revisão conforme chegarem — nenhuma ação necessária.",
    reviewTransactions: "Revisar Transações",
    linkFailed: "Falha ao vincular contas.",
  },

  // Diálogo de alteração de senha
  changePassword: {
    title: "Alterar Senha",
    description: "Digite sua senha atual e escolha uma nova.",
    currentPassword: "Senha Atual",
    currentPasswordRequired: "A senha atual é obrigatória",
    newPassword: "Nova Senha",
    newPasswordMin: "A senha deve ter pelo menos 8 caracteres",
    minHint: "Mínimo de 8 caracteres",
    confirmPassword: "Confirmar Nova Senha",
    confirmRequired: "Por favor, confirme sua nova senha",
    mismatch: "As senhas não coincidem",
    updatePassword: "Atualizar Senha",
    passwordUpdated: "Senha atualizada",
    passwordUpdatedDetail: "Sua senha foi alterada com sucesso.",
    changeFailed: "Falha ao alterar senha",
  },

  // Formulário de transação
  transactionFormPage: {
    pickDate: "Selecione uma data",
    descriptionPlaceholder: "ex: Supermercado, Salário, Aluguel",
    selectAccount: "Por favor, selecione uma conta",
    selectCurrency: "Por favor, selecione uma moeda",
    selectCategory: "Por favor, selecione uma categoria",
    pricePerShare: "Preço por Ação",
    pricePlaceholder: "ex: 43,67",
    quantity: "Quantidade",
    quantityAuto: "(auto)",
    quantityCalculated: "Calculado automaticamente",
    quantityPlaceholder: "ex: 1,23",
    detailsNotes: "Detalhes / Notas",
    notesPlaceholder: "Notas opcionais (substitui a descrição padrão da transação)",
    debtTerms: "Termos da Dívida",
    initialBalance: "Saldo Inicial",
    interestRate: "Taxa de Juros (%)",
    termMonths: "Prazo (em meses)",
    originationDate: "Data de Origem",
    tags: "Tags",
    saving: "Salvando...",
    updatedSuccess: "Transação atualizada com sucesso.",
    createdSuccess: "Transação criada com sucesso.",
    saveFailed: "Falha ao salvar transação. Por favor, tente novamente.",
    currencyMismatch: "Este ativo é negociado em {{currency}}. Por favor, selecione uma conta em {{currency}}.",
    currencyMismatchAlt: "Por favor, selecione uma conta em {{currency}} ou escolha um ativo negociado em {{txCurrency}}.",
    tickerRequired: "O ticker é obrigatório para esta categoria.",
    priceRequired: "O preço é obrigatório para esta categoria.",
    quantityRequired: "A quantidade é obrigatória para esta categoria.",
    dateLabel: "Data",
    descriptionLabel: "Descrição",
    accountLabel: "Conta",
    creditLabel: "Crédito",
    debitLabel: "Débito",
    categoryLabel: "Categoria",
    investmentDetails: "Detalhes do Investimento",
    investmentDetailsHint: "(selecione uma categoria de investimento para habilitar)",
    tickerLabel: "Ticker",
    tickerPlaceholder: "ex: AAPL, VWCE",
    etoroUsernameLabel: "Usuário do eToro",
    etoroUsernamePlaceholder: "Investidor copiado, ex.: topinvestor",
    copyTradeAmountHint: "Informe o valor que você colocou na cópia (ou retirou). Não há preço nem quantidade: o valor é o seu custo e o eToro fornece a cotação.",
    loadingFormData: "Carregando dados do formulário...",
    closePosition: "Fechar posição completa",
    closePositionHint: "Define a quantidade para sua posição exata de {{quantity}} unidades",
    closePositionActive: "Fechamento de posição ativo",
    lotMismatchWarning: "Incompatibilidade de quantidade na posição",
    lotMismatchDetail: "Esta posição apresenta quantidade negativa — pode estar faltando uma transação de compra ou uma transferência entre contas não registrada.",
  },

  // Formulário de termos de dívida
  debtTermsForm: {
    initialBalance: "Saldo Inicial",
    initialBalanceError: "O saldo inicial deve ser um número positivo.",
    interestRate: "Taxa de Juros (%)",
    interestRateNegative: "A taxa de juros não pode ser negativa.",
    interestRateTooHigh: "A taxa de juros parece muito alta.",
    termMonths: "Prazo (em meses)",
    termError: "O prazo deve ser um número positivo de meses.",
    originationDate: "Data de Origem",
    originationRequired: "A data de origem é obrigatória.",
    pickDate: "Selecione uma data",
    saveTerms: "Salvar Termos",
    saving: "Salvando...",
    success: "Sucesso!",
    savedDetail: "Os termos de dívida para {{name}} foram salvos.",
    saveFailed: "Falha ao salvar termos de dívida. Por favor, tente novamente.",
  },

  // Formulário de preço manual
  manualPriceForm: {
    date: "Data",
    pickDate: "Selecione uma data",
    price: "Preço",
    pricePlaceholder: "ex: 150,50",
    currency: "Moeda",
    currencyPlaceholder: "ex: USD",
    notes: "Notas (Opcional)",
    notesPlaceholder: "ex: Fonte da avaliação",
    savePrice: "Salvar Preço",
    saving: "Salvando...",
    success: "Sucesso!",
    savedDetail: "O preço de {{name}} foi atualizado.",
    saveFailed: "Falha ao atualizar preço. Por favor, tente novamente.",
  },

  manualPriceHistory: {
    title: "Histórico de preços — {{symbol}}",
    dialogDescription: "Revise, edite ou remova os preços que você registrou manualmente para este ativo.",
    addTitle: "Registrar um preço — {{symbol}}",
    editTitle: "Editar preço — {{symbol}}",
    countLabel_one: "{{count}} atualização",
    countLabel_other: "{{count}} atualizações",
    countLabel: "{{count}} atualizações",
    effectiveDate: "Data efetiva",
    price: "Preço",
    currency: "Moeda",
    notes: "Notas",
    recordedOn: "Registrado em",
    actions: "Ações",
    edit: "Editar",
    delete: "Excluir",
    back: "Voltar ao histórico",
    differentCurrency: "Esta entrada está registrada numa moeda diferente da do ativo.",
    emptyTitle: "Nenhum preço manual registrado ainda",
    emptyBody: "Registre o primeiro preço deste ativo para começar a construir seu histórico.",
    recordFirst: "Registrar primeiro preço",
    recordPrice: "Registrar preço",
    loadError: "Falha ao carregar o histórico de preços.",
    retry: "Tentar novamente",
    deleteConfirmTitle: "Excluir esta entrada de preço?",
    deleteConfirmBody: "Isto remove permanentemente o preço registrado e reativa a valoração do portfólio. Esta ação não pode ser desfeita.",
    deleted: "Entrada de preço excluída",
    deleteFailed: "Falha ao excluir a entrada de preço. Por favor, tente novamente.",
    viewHistory: "Ver histórico",
    lastUpdated: "Última atualização",
    allManualAssetsTitle: "Todos os ativos com preço manual",
    allManualAssetsDesc: "Todos os ativos que você precifica manualmente. Abra o histórico para revisar, editar ou remover entradas anteriores.",
    noManualAssets: "Nenhum ativo com preço manual ainda.",
    pagination: "Mostrando {{from}}–{{to}} de {{total}}",
    prev: "Anterior",
    next: "Próximo",
  },

  // Combobox de categoria
  categoryCombobox: {
    search: "Buscar categorias...",
    noResults: "Nenhuma categoria encontrada.",
  },

  // Formulário de categoria
  categoryFormPage: {
    nameMin: "O nome deve ter pelo menos 2 caracteres",
    typeRequired: "O tipo é obrigatório",
    groupRequired: "O grupo é obrigatório",
    iconLabel: "Ícone",
    iconHint: "Cole qualquer emoji para usar como ícone da categoria.",
    recurringLabel: "Cobrança recorrente",
    recurringHint: "Mostrar as transações desta categoria na visão de Assinaturas. Uma única cobrança já a inclui.",
    descriptionLabel: "Descrição",
    descriptionPlaceholder: "Explique brevemente quando usar esta categoria…",
    descriptionHint: "Exibida como tooltip no seletor de categorias. Ajuda você (ou outros usuários da sua conta) a escolher a categoria correta.",
    namePlaceholder: "ex: Supermercado, Salário, Aluguel",
    selectType: "Selecione o tipo",
    selectGroup: "Selecione o grupo",
    selectTypeFirst: "Selecione um tipo primeiro",
    createNewGroup: "+ Criar novo grupo\u2026",
    enterNewGroup: "Digite o nome do novo grupo",
    iconOptional: "(opcional)",
  },

  // Página de categorias
  categoriesPage: {
    defaultBadge: "Padrão",
    systemHint: "Categoria do sistema — usada para classificação de IA em todos os espaços. Não pode ser excluída.",
    transaction: "transação",
    transactions: "transações",
    categoryOptions: "Opções da categoria",
    rename: "Renomear",
    addTo: "Adicionar a {{type}}",
    reassignAndDelete: "Reatribuir e Excluir",
    reassignMessage: "\"{{name}}\" possui {{count}} transação(ões). Escolha uma categoria para reatribuí-las antes de excluir.",
    selectTargetCategory: "Selecione a categoria destino",
    deleteAndReassign: "Excluir e Reatribuir",
    deletedAndReassigned: "{{name}} excluída e {{count}} transação(ões) reatribuída(s)",
  },

  // Card de divisão de despesas (painel)
  expenseSplit: {
    title: "Divisão de Despesas",
    thisYear: "Este ano",
    thisMonth: "Este mês",
    lastMonth: "Mês passado",
    last3Months: "Últimos 3 meses",
    noData: "Sem dados de gastos para este período.",
    viewExpenses: "Ver despesas",
    ofSpending: "dos gastos",
    basis: "Débitos − créditos",
    netCredits: "Créditos líquidos",
    noNetSpend: "Sem gasto líquido neste período",
  },

  // Página de importação inteligente
  smartImport: {
    title: "Importação Inteligente",
    subtitle: "Faça upload de um arquivo CSV ou Excel, deixe a IA classificar suas transações, depois revise e consolide.",
    cancelImport: "Cancelar Importação",
    steps: {
      upload: "Upload",
      processing: "Processando",
      review: "Revisão",
      done: "Concluído",
    },
    status: {
      confirmed: "Confirmada",
      pending: "Pendente",
      duplicate: "Duplicada",
      possibleDup: "Possível Duplicata",
      skipped: "Pulada",
      error: "Erro",
    },
    source: {
      manual: "Manual",
      exact: "Exata",
      vector: "Vetor",
      ai: "IA",
    },
    selectFile: "Selecionar Arquivo",
    selectFileDesc: "Escolha um extrato bancário ou arquivo de exportação (CSV ou Excel) para importar.",
    dropzone: "Clique para selecionar ou arraste um arquivo CSV ou Excel",
    detectingFormat: "Detectando formato do arquivo...",
    formatDetected: "Formato Detectado: {{name}}",
    formatDetectedDesc: "Este arquivo corresponde ao adaptador {{name}}. O mapeamento de colunas será aplicado automaticamente.",
    unknownFormat: "Formato Desconhecido",
    unknownFormatDesc: "Nenhum adaptador corresponde a este arquivo. Cabeçalhos detectados:",
    unknownFormatHeaderHint: "O Bliss lê os cabeçalhos das colunas na primeira linha do arquivo (ou da planilha, no Excel). Se o arquivo tiver linhas acima dos cabeçalhos — nome da conta, período, saldo —, apague-as e envie o arquivo novamente.",
    createAdapterForFormat: "Criar Adaptador para este Formato",
    destinationAccount: "Conta de Destino",
    destinationAccountDesc: "Todas as transações serão importadas para esta conta.",
    destinationAccountNative: "Opcional — o adaptador nativo resolve a conta por linha do seu CSV.",
    selectAccount: "Selecione uma conta...",
    optionalFromCsv: "Opcional — obtido do CSV...",
    nativeAccountHint: "A coluna de conta de cada linha substitui esta seleção. Selecione um padrão aqui apenas se algumas linhas não tiverem conta especificada.",
    uploading: "Enviando...",
    uploadAndProcess: "Enviar e Processar",
    importAdapters: "Adaptadores de Importação",
    hide: "Ocultar",
    manage: "Gerenciar",
    noAdapters: "Nenhum adaptador ainda. Crie um para começar a importar.",
    newAdapter: "Novo Adaptador",
    system: "Sistema",
    template: "Modelo",
    editAdapter: "Editar Adaptador",
    createAdapter: "Criar Adaptador",
    adapterFormDesc: "Defina como as colunas do CSV/Excel do seu banco mapeiam para os campos de transação do Bliss.",
    form: {
      name: "Nome",
      nameRequired: "O nome do adaptador é obrigatório",
      namePlaceholder: "CSV Conta Corrente Itaú",
      matchHeaders: "Cabeçalhos de Correspondência",
      matchHeadersPlaceholder: "Data, Descrição, Valor",
      matchHeadersHint: "Cabeçalhos de coluna que identificam exclusivamente o formato de exportação deste banco.",
      matchHeadersChipsHint: "Selecione os cabeçalhos do seu arquivo que identificam este formato. Adicione um personalizado se necessário.",
      addCustomHeader: "Adicionar cabeçalho personalizado",
      dateColumn: "Coluna de Data",
      dateColumnPlaceholder: "Data",
      descriptionColumn: "Coluna de Descrição",
      descriptionColumnPlaceholder: "Descrição",
      amountStrategy: "Layout do Valor",
      singleSigned: "Uma coluna, com sinal (maioria dos bancos)",
      singleSignedDesc: "Ex. -45,20 = despesa, 25,00 = receita",
      singleSignedInverted: "Uma coluna, sinais invertidos (ex. Amex)",
      singleSignedInvertedDesc: "Ex. 45,20 = despesa, -25,00 = reembolso",
      debitCredit: "Colunas separadas de Débito e Crédito",
      debitCreditDesc: "Duas colunas separadas para débitos e créditos",
      amountWithType: "Valor + Coluna de Tipo",
      amountWithTypeDesc: "Uma coluna de valor e outra indicando a direção",
      typeColumn: "Coluna de Tipo",
      typeColumnPlaceholder: "Tipo",
      categoryColumn: "Coluna de Categoria (opcional)",
      categoryColumnPlaceholder: "Nenhuma — sem sugestão de categoria",
      categoryColumnHint: "Se o seu arquivo tiver coluna de categoria, mapeá-la melhora a precisão da IA",
      debitColumn: "Coluna de Débito",
      debitColumnPlaceholder: "Débito",
      creditColumn: "Coluna de Crédito",
      creditColumnPlaceholder: "Crédito",
      amountColumn: "Coluna de Valor",
      amountColumnPlaceholder: "Valor",
      customColumn: "Coluna personalizada…",
      dateFormat: "Formato de Data",
      dateFormatAuto: "Detecção automática (recomendado)",
      dateFormatCustom: "Formato personalizado…",
      dateFormatGroupDate: "Somente data",
      dateFormatGroupDateTime: "Data + Hora",
      dateFormatAmbiguousWarning: "Formato de data ambíguo (todos os valores ≤ 12). Selecione um formato explícito para evitar erros MM/DD vs DD/MM.",
      dateFormatHint: "Escolha um formato ou selecione Personalizado",
      defaultCurrency: "Moeda Padrão",
      currencyHint: "Deixe em branco se o seu CSV tiver coluna de moeda por linha",
      currencyNone: "Nenhuma — usar coluna de moeda por linha",
      skipRows: "Pular Linhas (linhas de cabeçalho a pular)",
      previewTitle: "Pré-visualização linha 1",
      previewHint: "Preencha as colunas acima para ver como a linha 1 será interpretada",
      previewNoData: "Envie um arquivo primeiro para ativar a pré-visualização",
      previewDate: "Data",
      previewDescription: "Descrição",
      previewAmount: "Valor",
      previewCurrency: "Moeda",
      previewBankCategory: "Categoria do banco",
    },
    unknownFormatSamplePreview: "Linhas de amostra do seu arquivo:",
    processingTitle: "Processando Sua Importação",
    processingDesc: "A IA está classificando suas transações. Isso pode levar um momento...",
    percentComplete: "{{pct}}% concluído",
    unknownAccount: "Conta Desconhecida",
    quickClassify: "Classificação Rápida",
    quickClassifyDesc: "Encontramos suas transações mais recorrentes. Confirme ou ajuste suas categorias para tornar a IA mais inteligente em importações futuras.",
    skipForNow: "Pular por enquanto",
    confirmAndContinue: "Confirmar e Continuar",
    confirmAll: "Confirmar Tudo",
    seed: {
      global: "Global",
      match: "Correspondência",
      restore: "Restaurar",
      skipMerchant: "Pular este estabelecimento",
    },
    review: {
      file: "Arquivo",
      account: "Conta",
      total: "Total",
      nRows: "{{count}} linhas",
      earliest: "Mais antiga",
      autoConfirmed: "{{count}} confirmadas automaticamente",
      nUpdates: "{{count}} atualizações",
      pendingReview: "{{count}} pendentes de revisão",
      nDuplicates: "{{count}} duplicatas",
      nErrors: "{{count}} erros",
      filterByStatus: "Filtrar por status",
      flat: "Simples",
      grouped: "Agrupado",
      errorLoadingTitle: "Erro ao Carregar Importação",
      errorLoadingDesc: "Não foi possível carregar os dados da importação preparada. Tente atualizar a página.",
      noRowsFound: "Nenhuma linha encontrada",
      tryDifferentFilter: "Tente um filtro diferente.",
      noRowsProduced: "A importação não produziu nenhuma linha.",
      pageOf: "Página {{current}} de {{total}}",
    },
    filter: {
      allRows: "Todas as Linhas",
      possibleDuplicate: "Possível Duplicata",
    },
    committingTitle: "Consolidando Transações",
    committingDesc: "Criando transações a partir das suas linhas confirmadas...",
    committing: "Consolidando...",
    commitImport: "Consolidar Confirmadas",
    importError: "Erro na Importação",
    processingError: "Ocorreu um erro durante o processamento.",
    processingFailed: "Processamento falhou",
    startOver: "Recomeçar",
    importComplete: "Importação Concluída!",
    importCompleteDesc: "Suas transações foram consolidadas com sucesso.",
    done: {
      created: "Criadas",
      updated: "Atualizadas",
      remaining: "Restantes",
    },
    importAnotherFile: "Importar Outro Arquivo",
    reviewInTransactionReview: "Revisar na Revisão de Transações",
    commitDialogDesc: "Isso criará transações apenas para as linhas confirmadas. Linhas pendentes permanecerão disponíveis para revisão futura. Esta ação não pode ser desfeita.",
    goBack: "Voltar",
    yesCommit: "Sim, Consolidar",
    cancelDialogDesc: "Tem certeza de que deseja cancelar? Todas as linhas preparadas serão descartadas.",
    cancelling: "Cancelando...",
    yesCancelImport: "Sim, Cancelar Importação",
    toast: {
      importReady: "Importação Pronta",
      rowsReady: "{{count}} linhas prontas para revisão.",
      seedSaveFailed: "Não foi possível salvar as seleções de categoria.",
      detectionFailed: "Detecção Falhou",
      detectionFailedDesc: "Não foi possível detectar o formato do arquivo. Verifique seu arquivo CSV ou Excel.",
      uploadFailed: "Upload Falhou",
      uploadFailedDesc: "Não foi possível iniciar a importação. Por favor, tente novamente.",
      otherTransactions: "{{count}} outras transações em \"{{category}}\"",
      confirmAllQuestion: "Confirmar todas?",
      confirmedN: "{{count}} transações confirmadas",
      commitStarted: "Consolidação Iniciada",
      commitStartedDesc: "Suas transações estão sendo consolidadas...",
      commitFailed: "Consolidação Falhou",
      commitFailedDesc: "Não foi possível iniciar o processo de consolidação.",
      importCancelled: "Importação Cancelada",
      cancelFailed: "Cancelamento Falhou",
      adapterUpdated: "Adaptador atualizado",
      adapterCreated: "Adaptador criado",
      adapterDeleted: "Adaptador excluído",
      formatMatched: "Formato correspondente: {{name}}",
      formatMatchedDesc: "Seu arquivo foi reconhecido. Você pode prosseguir com o upload.",
      updateFailed: "Atualização falhou",
      createFailed: "Criação falhou",
      deleteFailed: "Exclusão falhou",
    },
  },

  // Página de insights
  insights: {
    title: "Insights",
    subtitle: "Observações com inteligência artificial sobre suas finanças",
    v1Subtitle: "Inteligência financeira com IA: revisões mensais, tendências trimestrais, recapitulações anuais e análise de portfólio",
    lastUpdated: "Última atualização",
    generating: "Gerando...",
    generateNew: "Gerar Novos Insights",
    generate: "Gerar Insights",
    generateAll: "Gerar todos os níveis",
    refresh: "Atualizar",
    refreshTier: "Regenerar",
    moreActions: "Mais ações",
    reload: "Recarregar",
    clearFilters: "Limpar filtros",
    noInsightsYet: "Nenhum insight ainda",
    noInsightsDesc: "Quando você tiver dados de transação, o Bliss analisará suas finanças e destacará padrões relevantes.",
    noCategoryInsights: "Nenhum insight corresponde às categorias selecionadas para este período.",
    noTierInsightsDesc: "Nenhum insight foi gerado para este nível ainda. Use Regenerar para criar um para o período mais recente.",
    period: {
      selectPlaceholder: "Selecionar período",
      q: "T",
    },
    severity: {
      POSITIVE: "Positivo",
      INFO: "Informação",
      WARNING: "Aviso",
      CRITICAL: "Crítico",
    },
    categories: {
      all: "Todos",
      spending: "Gastos",
      income: "Receitas",
      savings: "Poupança",
      portfolio: "Portfólio",
      debt: "Dívidas",
      netWorth: "Patrimônio líquido",
    },
    tiers: {
      monthly: "Revisão mensal",
      quarterly: "Análise trimestral",
      annual: "Relatório anual",
      portfolio: "Inteligência de portfólio",
    },
    lens: {
      passiveIncomeOutlook: "Perspectiva de renda passiva",
    },
    actions: {
      passiveIncomeSetup: "Configurar condições de renda",
      portfolioHoldings: "Carteira de Investimentos",
    },
  },

  // Página de atualizações manuais
  manualUpdates: {
    pageTitle: "Atualizações Manuais e Termos",
    pageSubtitle: "Mantenha seus ativos manuais e passivos atualizados.",
    errorLoading: "Falha ao carregar dados dos ativos. Por favor, tente novamente mais tarde.",
    stalePricesTitle: "Ação Necessária: Preços Desatualizados",
    stalePricesDesc: "Estes ativos rastreados manualmente não são atualizados há mais de 30 dias.",
    asset: "Ativo",
    value: "Valor",
    status: "Status",
    action: "Ação",
    never: "Nunca",
    updatedOn: "Atualizado em {{date}}",
    dOld: "{{count}}d desatualizado",
    updatePrice: "Atualizar Preço",
    allUpToDate: "Todos os ativos rastreados manualmente estão atualizados.",
    liabilityTerms: "Termos de Passivos",
    liabilityTermsDesc: "Gerencie os termos dos seus empréstimos e linhas de crédito rastreados manualmente.",
    debtName: "Nome da Dívida",
    principalBalance: "Saldo Principal",
    interestRate: "Taxa de Juros",
    duration: "Duração",
    yr: "ano",
    mo: "mês",
    editTerms: "Editar Termos",
    addTerms: "Adicionar Termos",
    totalOutstanding: "Total Pendente",
    noLiabilities: "Nenhum passivo encontrado.",
    updatePriceDialog: "Atualizar Preço",
    debtTermsDialog: "Termos da Dívida",
    urgency: {
      critical: "Crítico",
      warning: "Aviso",
      stale: "Desatualizado",
    },
  },

  // Gráfico de gastos por categoria
  spendingChart: {
    title: "Gastos por Categoria",
    selectPeriod: "Selecione o período",
    thisMonth: "Este mês",
    lastMonth: "Mês passado",
    last3Months: "Últimos 3 meses",
    noData: "Sem dados de gastos para este período.",
  },

  // Página de carteira de investimentos
  portfolio: {
    title: "Carteira de Investimentos",
    subtitle: "Acompanhe o desempenho e a alocação da sua carteira de investimentos",
    assets: "Ativos",
    liabilities: "Passivos",
    positionCount_one: "{{count}} posição",
    positionCount_other: "{{count}} posições",
    positionCount: "{{count}} posições",
    symbol: "Símbolo",
    qty: "Qtd",
    price: "Preço",
    costBasis: "Custo Base",
    unrealizedPnL: "P&L Não Realizado",
    realizedPnL: "P&L Realizado",
    roiPercent: "ROI %",
    totalValue: "Valor Total",
    roiTooltip: "ROI Total = (P&L Realizado + Não Realizado) / Total Investido",
    showDebt: "Mostrar Dívida",
    allAccounts: "Todas as contas",
    allCountries: "Todos os países",
    noHistoricalData: "Sem dados históricos disponíveis para este período.",
    // Holding filter (#131)
    allHoldings: "Todas as posições",
    searchHoldings: "Pesquisar posições…",
    noHoldingsFound: "Nenhuma posição encontrada.",
    showClosedPositionsToggle: "Mostrar posições encerradas",
    closedBadge: "Encerrada",
    closedPositionsGroup: "Posições encerradas",
    clearHolding: "Limpar filtro de posição",
    showInChart: "Mostrar no gráfico",
    holdingNotInAccount: "{{symbol}} não está em {{account}}",
    noHistoryForHolding: "Sem histórico de {{name}} neste período",
    holdingPickerLabel: "Filtrar o gráfico por posição",
    netWorth: "Patrimônio Líquido",
    emptyState: "Sem dados de carteira ainda. Conecte uma conta bancária ou importe transações para começar.",
    connectAccount: "Conectar Conta",
    importCSV: "Importar CSV",
    errorTitle: "Erro ao Carregar Carteira",
    errorDescription: "Houve um problema ao buscar os dados da sua carteira. Por favor, tente novamente mais tarde.",
    liability: "Passivo",
    interestRate: "Taxa de Juros",
    term: "Prazo",
    balance: "Saldo",
    totalOutstanding: "Total Pendente",
    editTerms: "Editar Termos",
    addTerms: "Adicionar Termos",
    hideClosedPositions_one: "Ocultar {{count}} posição encerrada",
    hideClosedPositions_other: "Ocultar {{count}} posições encerradas",
    hideClosedPositions: "Ocultar {{count}} posições encerradas",
    showClosedPositions_one: "Mostrar {{count}} posição encerrada",
    showClosedPositions_other: "Mostrar {{count}} posições encerradas",
    showClosedPositions: "Mostrar {{count}} posições encerradas",
  },

  // Página de análise por tags
  tagAnalytics: {
    title: "Análise por Tags",
    subtitle: "Analise gastos por tag em todas as contas e moedas",
    selectTag: "Selecione uma tag...",
    compare: "Comparar",
    compareWith: "Comparar com...",
    searchTags: "Buscar tags...",
    noTagsFound: "Nenhuma tag encontrada.",
    emptyTitle: "Selecione uma tag para ver a análise",
    emptyDescription: "Escolha uma tag acima para ver detalhamentos de gastos, tendências e acompanhamento de orçamento",
    totalDebit: "Total de Débito",
    totalCredit: "Total de Crédito",
    balance: "Saldo",
    budgetProgress: "Progresso do Orçamento",
    topCategory: "Categoria Principal",
    categoryBreakdown: "Detalhamento por Categoria",
    noSpendingData: "Sem dados de gastos para esta tag",
    cashFlowTimeline: "Linha do Tempo do Fluxo de Caixa",
    noTimelineData: "Sem dados de linha do tempo",
    monthly: "Mensal",
  },

  // Auth page — flat string keys
  "Sign In": "Entrar",
  "Sign Up": "Cadastrar",
  "Sign in with Google": "Entrar com Google",

  // Auth rejection messages (task #71 — identity hygiene)
  "An account with this email already exists. Sign in with your password instead.": "Já existe uma conta com este e-mail. Inicie sessão com a sua palavra-passe.",
  "Your Google account's email address is not verified. Verify it with Google, then try again.": "O endereço de e-mail da sua conta Google não está verificado. Verifique-o junto da Google e tente novamente.",
  "Sign-in with Google failed. Please try again.": "Não foi possível iniciar sessão com a Google. Tente novamente.",
  "We could not sign you in automatically. Please try signing in with your password.": "Não conseguimos iniciar a sua sessão automaticamente. Tente iniciar sessão com a sua palavra-passe.",

  // Invite-only sign-up (task #99)
  "This Bliss instance is invite-only. Use the email address you were invited with.": "Esta instância do Bliss é apenas por convite. Utilize o endereço de e-mail com que foi convidado.",
  "This email hasn't been invited to this Bliss instance. Ask the person who runs it for an invite.": "Este e-mail não foi convidado para esta instância do Bliss. Peça um convite à pessoa que a gere.",
  "Sign up with Google": "Cadastrar com Google",
  "or continue with email": "ou continue com e-mail",
  "Email address": "Endereço de e-mail",
  "Password": "Senha",
  "Signing in...": "Entrando...",
  "Login failed": "Falha no login",
  "Full name": "Nome completo",
  "Use at least 8 characters, including a number.": "Use pelo menos 8 caracteres, incluindo um número.",
  "By creating an account you agree to our": "Ao criar uma conta, você concorda com nossos",
  "and": "e",
  "Registration failed": "Falha no cadastro",
  "Creating account...": "Criando conta...",
  "Create Account": "Criar Conta",
  "Don't have an account?": "Não tem uma conta?",
  "Create one": "Crie uma",
  "Already have an account?": "Já tem uma conta?",
  "Sign in": "Entrar",
  "Welcome to the Bliss demo. Use the credentials below to sign in and explore.": "Bem-vindo à demo do Bliss. Use as credenciais abaixo para entrar e explorar.",
  "The quiet intelligence behind your global wealth.": "A inteligência silenciosa por trás do seu patrimônio global.",
  "Financial clarity, without borders.": "Clareza financeira, sem fronteiras.",
  "Bliss capybara in a turtleneck, seated in a mid-century chair beside a stack of currency coins": "Capivara do Bliss de gola alta, sentada em uma cadeira mid-century ao lado de moedas",
  "Bliss capybara mascot seated in a mid-century chair": "Mascote capivara do Bliss sentada em uma cadeira mid-century",
  "Welcome back": "Bem-vindo de volta",
  "Protected by enterprise-grade encryption.": "Protegido por criptografia de nível empresarial.",

  // Dashboard actions — flat string keys
  "Fix Bank Connection": "Corrigir conexão bancária",
  "A bank connection needs your attention": "Uma conexão bancária precisa da sua atenção",
  "Review Pending Transactions": "Revisar transações pendentes",
  "Check and categorize imported transactions": "Verifique e categorize as transações importadas",
  "Update Asset Prices": "Atualizar preços de ativos",
  "Some manual assets need a price refresh": "Alguns ativos manuais precisam de atualização de preço",
  "Connect your bank": "Conecte seu banco",
  "Plaid (US, CA, UK) or Enable Banking (EU) for automatic sync": "Plaid (EUA, CA, Reino Unido) ou Enable Banking (UE) para sincronização automática",
  "Add Manual Account": "Adicionar conta manual",
  "Manually track an account or asset": "Rastreie manualmente uma conta ou ativo",
  "Import Transactions": "Importar transações",
  "Upload a CSV file to import transactions": "Carregue um arquivo CSV para importar transações",
  "View Insights": "Ver insights",
  "See AI-generated financial observations": "Ver observações financeiras geradas por IA",
  "Explore Expenses": "Explorar despesas",
  "See how your spending breaks down": "Veja como seus gastos se distribuem",
  "View Financial Summary": "Ver Resumo Financeiro",
  "View income vs expenses over time": "Ver receitas vs despesas ao longo do tempo",
  "View Accounts": "Ver contas",
  "See all your connected accounts": "Ver todas as suas contas conectadas",

  // Setup checklist — flat string keys
  "Get started with Bliss": "Comece com o Bliss",
  "of": "de",
  "complete": "concluído",
  "Dismiss": "Fechar",
  // ─── Subscriptions / recurring charges ───────────────────────────────────────
  subscriptions: {
    title: "Assinaturas",
    subtitle: "Cobranças recorrentes detectadas nas suas contas.",
    scanNow: "Escanear agora",
    scanCooldownShort: "Escanear em {{count}} min",
    scanStarted: "Verificação iniciada",
    scanStartedHint: "A detecção está em execução em segundo plano. Os resultados aparecem em breve.",
    scanCooldown: "Verificação em espera",
    scanCooldownHint: "Você poderá escanear novamente em cerca de {{count}} minutos.",
    actionFailed: "A ação falhou",
    fullScanHintPrefix: "Assinaturas anuais antigas podem estar faltando —",
    fullScanHintLink: "execute uma varredura do histórico completo",
    fullScanHintSuffix: " em Configurações → Manutenção.",
    loadError: "Não foi possível carregar as assinaturas.",
    uncategorized: "Sem categoria",
    toggleCharges: "Mostrar cobranças individuais",
    noCharges: "Nenhuma cobrança encontrada para este estabelecimento.",
    fxUnavailable: "Sem câmbio",
    occurrences_one: "{{count}} cobrança",
    occurrences_other: "{{count}} cobranças",
    confirm: "Confirmar",
    confirmed: "Marcada como assinatura",
    notASubscription: "Não é uma assinatura",
    dismissed: "Removida das assinaturas",
    remove: "Remover",
    removed: "Removida",
    restore: "Restaurar",
    restored: "Restaurada",
    summary: {
      monthly: "Mensal",
      annual: "Anualizado",
      count: "Assinaturas ativas",
      fxExcluded: "{{count}} excluídas (sem taxa de câmbio)",
    },
    filter: {
      active: "Ativas",
      lapsed: "Expiradas",
      all: "Todas",
      allCategories: "Todas as categorias",
    },
    empty: {
      title: "Ainda não há cobranças recorrentes",
      body: "Quando um estabelecimento cobrar você algumas vezes, aparecerá aqui.",
    },
    status: {
      active: "Ativa",
      lapsed: "Expirada",
    },
    cadence: {
      WEEKLY: "Semanal",
      MONTHLY: "Mensal",
      QUARTERLY: "Trimestral",
      ANNUAL: "Anual",
      unknown: "Desconhecida",
    },
    due: {
      today: "vence hoje",
      inDays: "vence em {{count}} d",
      agoDays: "atrasada {{count}} d",
    },
    rename: {
      label: "Renomear assinatura",
      renamed: "Assinatura renomeada",
      custom: "nome personalizado",
    },
    merge: {
      mergeInto: "Unir a outra assinatura",
      pickTarget: "Escolha uma assinatura…",
      merged: "Assinaturas unidas",
      unmerge: "Desfazer união",
      unmerged: "União desfeita",
      tombstoneHint: "Integrada a outra assinatura — suas cobranças contam para ela.",
      unknownTarget: "outra assinatura",
      mergedCountHint_one: "{{count}} unida a outra — gerenciar",
      mergedCountHint_other: "{{count}} unidas a outras — gerenciar",
      targetMissing: "Destino da junção ausente",
      stale: "Esta junção não está a ter efeito — tente desfazer e juntar novamente.",
      dismissBlocked: "Primeiro desfaça a junção das linhas integradas nesta.",
    },
    split: {
      splitByAmount: "Separar por valor — uma assinatura por preço",
      split: "Separada em uma assinatura por valor",
      unsplit: "Desfazer separação",
      unsplitDone: "Separação desfeita",
      markerHint: "Separada por valor — cada preço recorrente é uma assinatura própria.",
      nothingToSplit: "Essas cobranças não se repetem em dois ou mais valores diferentes.",
    },
    pager: {
      prev: "Anterior",
      next: "Próxima",
      pageOf: "Página {{page}} de {{total}}",
    },
  },

  // Passive Income (#77)
  passiveIncome: {
    title: "Renda passiva",
    subtitle: "Dividendos, cupons, aluguéis, juros e benefícios projetados ao lado do que você realmente recebeu",
    loadFailed: "Falha ao carregar a renda passiva.",
    horizon: "Horizonte de projeção",
    months_one: "{{count}} mês",
    months_other: "{{count}} meses",
    kpi: {
      next12m: "Próximos 12 meses",
      split: "{{investment}} investimentos · {{other}} outros",
      monthlyAverage: "Média mensal",
      yieldOnValue: "Rendimento sobre valor",
      yieldHint: "Apenas renda de investimentos",
      essentialsCoverage: "Gastos essenciais cobertos",
      essentialsHint: "de {{amount}} gastos nos últimos 12 meses",
      noEssentials: "Nenhum gasto essencial registrado",
      dataCoverage: "Cobertura de dados",
      dataCoverageValue: "{{configured}} de {{total}}",
      dataCoverageHint: "posições geradoras de renda configuradas",
    },
    chart: {
      title: "Renda real vs projetada",
      actual: "Real",
      today: "Hoje",
    },
    bucket: {
      dividend: "Dividendos",
      coupon: "Cupons",
      rent: "Aluguéis",
      interest: "Juros",
      other: "Mesadas e benefícios",
    },
    frequency: {
      WEEKLY: "Semanal",
      MONTHLY: "Mensal",
      QUARTERLY: "Trimestral",
      SEMIANNUAL: "Semestral",
      ANNUAL: "Anual",
      AT_MATURITY: "No vencimento",
      IRREGULAR: "Irregular",
      MIXED: "Mista",
      NONE: "Sem pagamentos",
    },
    incomeType: {
      DIVIDEND: "Dividendo",
      FIXED_COUPON: "Título prefixado",
      FLOATING_COUPON: "Título pós-fixado",
      INFLATION_LINKED: "Título atrelado à inflação",
      RENT: "Aluguel",
      INTEREST: "Juros",
      CUSTOM_YIELD: "Rendimento",
      FIXED_AMOUNT: "Valor fixo",
      NONE: "Sem renda",
    },
    source: {
      AUTO: "Automático",
      OVERRIDE: "Personalizado",
      MANUAL: "Manual",
      MISSING: "Faltando",
      MIXED: "Misto",
    },
    status: {
      OK: "OK",
      MATURED_UNREDEEMED: "Vencido: registre o resgate",
      ENDED: "Encerrado",
      STALE_RATE: "A taxa pode estar desatualizada",
    },
    yearly: {
      title: "Resumo anual",
      source: "Origem",
      year: "Ano {{n}}",
      total: "Total",
    },
    upcoming: {
      title: "Próximos pagamentos",
      empty: "Nenhum pagamento previsto ainda.",
    },
    breakdown: {
      filters: {
        all: "Tudo",
        assets: "Posições",
        streams: "Fluxos",
        attention: "Requer atenção",
      },
      search: "Buscar posições ou fluxos",
      filter: "Filtrar",
      noMatches: "Nada corresponde à sua busca.",
      showing: "{{from}}–{{to}} de {{total}}",
      prev: "Página anterior",
      next: "Próxima página",
      title: "Detalhamento por posição ou fluxo",
      description: "Projetado para os próximos {{count}} meses",
      empty: "Nenhuma renda configurada ainda. Adicione condições de renda às suas posições ou um fluxo de renda.",
      holding: "Posição / fluxo",
      type: "Tipo",
      rateOrAmount: "Taxa / valor",
      frequency: "Frequência",
      nextPayment: "Próximo pagamento",
      endDate: "Termina",
      horizonTotal: "Projetado",
      mixed: "Misto",
      accounts_one: "{{count}} conta",
      accounts_other: "{{count}} contas",
      showAccounts_one: "Mostrar {{count}} conta",
      showAccounts_other: "Mostrar {{count}} contas",
      hideAccounts: "Ocultar contas",
      editGroup: "Editar as condições de renda de todas as posições de {{name}}",
      cashSummary: "Saldo {{balance}} · {{monthly}}/mês",
      quantity: "{{value}} unidades",
      view: {
        label: "Visualização do detalhamento",
        grouped: "Por ativo",
        flat: "Por conta",
      },
    },
    ladder: {
      title: "Escada de vencimentos",
      description: "Principal devolvido por ano (não conta como renda)",
      empty: "Nenhum título vence neste horizonte.",
    },
    streams: {
      title: "Outros fluxos de renda",
      description: "Mesadas e benefícios governamentais não vinculados a um ativo",
      add: "Adicionar fluxo",
      empty: "Nenhum fluxo de renda ainda.",
      noCategories: "Crie uma categoria Mesada ou Benefícios governamentais no grupo Renda passiva para adicionar fluxos.",
    },
    missing: {
      showAll: "Ver todas ({{count}})",
      showLess: "Ver menos",
      title_one: "{{count}} posição não tem dados de renda",
      title_other: "{{count}} posições não têm dados de renda",
      description: "Adicione as condições de renda ou marque-as como sem distribuição para completar a projeção.",
    },
    detached: {
      searchAsset: "Buscar posições…",
      noAssets: "Nenhuma posição sem condições de renda.",
      title: "Condições de renda desvinculadas",
      description: "Essas condições pertenciam a posições recriadas após uma importação corrigida. Vincule-as novamente à posição correta ou descarte-as.",
      unnamed: "Posição sem nome",
      detachedOn: "desvinculado em {{date}}",
      reattach: "Vincular novamente",
      discard: "Descartar",
      pickAsset: "Escolha uma posição",
      confirmAttach: "Vincular",
      attached: "Condições de renda vinculadas",
      attachFailed: "Não foi possível vincular as condições de renda.",
      discardTitle: "Descartar estas condições de renda?",
      discardConfirm: "Elas serão excluídas permanentemente.",
      discarded: "Condições de renda descartadas",
      discardFailed: "Não foi possível descartar as condições de renda.",
    },
  },
  incomeTerms: {
    faceValueHint_one: "{{units}} unidade em carteira · {{perUnit}} por unidade",
    faceValueHint_other: "{{units}} unidades em carteira · {{perUnit}} por unidade",
    pickDate: "Escolha uma data",
    clearDate: "Limpar data",
    action: "Condições de renda",
    actionConfigured: "Condições de renda (configuradas)",
    title: "Condições de renda — {{name}}",
    addStreamTitle: "Adicionar fluxo de renda",
    editStreamTitle: "Editar fluxo de renda",
    assetDescription: "Informe ao Bliss o que esta posição paga para projetar sua renda passiva. Valores brutos.",
    streamDescription: "Uma renda recorrente não vinculada a um ativo, como uma mesada ou uma aposentadoria pública.",
    notIncomeCapable: "Esta posição não pode gerar renda passiva.",
    autoTitle: "Dados automáticos de dividendos",
    autoSummary: "{{count}} pagamentos nos últimos 12 meses ({{frequency}}) · {{amount}} por ação · última data ex {{date}}",
    autoNone: "Sem dividendos nos últimos 12 meses (ex.: um fundo de acumulação). Projeta zero e não é marcado como faltante.",
    autoUnavailable: "Ainda não há dados confiáveis de dividendos. Adicione um valor personalizado abaixo.",
    override: "Substituir os dividendos automáticos",
    notDistributing: "Não distribui renda",
    groupTitle_one: "Condições de renda — {{name}} ({{count}} conta)",
    groupTitle_other: "Condições de renda — {{name}} ({{count}} contas)",
    applyToAllHoldings_one: "Aplicar a todas as posições de {{symbol}} ({{count}})",
    applyToAllHoldings_other: "Aplicar às {{count}} posições de {{symbol}}",
    appliesToHoldings_one: "Aplica-se a {{count}} posição de {{symbol}}",
    appliesToHoldings_other: "Aplica-se a {{count}} posições de {{symbol}}",
    mixedTitle: "Estas posições não têm as mesmas condições",
    mixedDescription: "Cada conta de {{symbol}} tem hoje seus próprios dados de renda. Escolha uma conta como ponto de partida.",
    mixedAccount: "Conta",
    mixedUseSame: "Usar as mesmas condições para todas",
    mixedEditOne: "Editar só esta conta",
    removeFromAllConfirm_one: "As condições de renda serão removidas de {{count}} posição de {{symbol}}. Ações e ETFs voltam aos dados automáticos.",
    removeFromAllConfirm_other: "As condições de renda serão removidas das {{count}} posições de {{symbol}}. Ações e ETFs voltam aos dados automáticos.",
    faceValuePerUnitGroupHint_one: "{{units}} unidade em {{count}} posição · {{total}} no total",
    faceValuePerUnitGroupHint_other: "{{units}} unidades em {{count}} posições · {{total}} no total",
    select: "Selecionar…",
    none: "Nenhum",
    otherIndex: "Outro",
    namePlaceholder: "ex.: Aposentadoria do INSS",
    netRentHint: "Informe o aluguel que você realmente recebe após custos e vacância.",
    previewAnnual: "≈ {{amount}} / ano",
    previewNext: "próximo pagamento {{date}}",
    previewEnds: "termina em {{year}}",
    removeTerms: "Remover condições",
    deleteStream: "Excluir fluxo",
    saved: "Condições de renda salvas",
    deleted: "Condições de renda removidas",
    saveFailed: "Não foi possível salvar as condições de renda.",
    issuer: {
      GOVERNMENT: "Governo",
      CORPORATE: "Corporativo",
    },
    fields: {
      faceValueTotal: "Valor de face total",
      incomeType: "Tipo de renda",
      issuerType: "Emissor",
      faceValuePerUnit: "Valor de face por unidade",
      couponRate: "Taxa do cupom",
      realCoupon: "Cupom real",
      referenceIndex: "Índice de referência",
      assumedIndexRate: "Taxa estimada do índice",
      spread: "Spread",
      frequency: "Frequência",
      maturityDate: "Data de vencimento",
      anchorPaymentDate: "Uma data de pagamento",
      monthlyRent: "Aluguel mensal líquido",
      annualIndexationPct: "Reajuste anual",
      leaseStart: "Início do contrato",
      leaseEndDate: "Fim do contrato",
      apyPct: "Rendimento anual",
      yieldPct: "Rendimento",
      orYieldPct: "…ou rendimento",
      dividendPerUnit: "Dividendo anual por ação",
      name: "Nome",
      category: "Categoria",
      amountPerPayment: "Valor por pagamento",
      currency: "Moeda",
      startDate: "Data de início",
      endDate: "Data de término",
    },
    errors: {
      required: "Obrigatório",
      invalid: "Valor inválido",
      number: "Informe um número",
      negative: "Não pode ser negativo",
      date: "Informe uma data válida",
      endBeforeStart: "Deve ser após a data de início",
      currency: "Use um código de 3 letras (ex.: EUR)",
    },
  },
  maintenance: {
    fullRebuildSecuritiesStep: "Também atualiza os dados de títulos das suas ações e ETFs com dados ausentes ou desatualizados.",
    securityData: {
      title: "Atualizar os dados dos meus títulos",
      description: "Busca novamente perfil, dividendos e cotações de todas as ações e ETFs que você possui (resultados só para ações). Use quando o calendário de dividendos ou a análise de ações parecer incorreto.",
      button: "Atualizar títulos",
    },
    globalFundamentals: {
      title: "Atualizar fundamentos de todos os símbolos (global)",
      description: "Atualiza a tabela SecurityMaster compartilhada para todos os símbolos de todos os inquilinos, não só os seus. Mais pesado que atualizar seus títulos; use após um incidente do provedor de dados.",
    },
  },

  // Manage Assets page (#81)
  manageAssets: {
    title: "Gerir ativos",
    subtitle: "Todos os seus ativos e passivos num só lugar: preços, termos de rendimento, termos de dívida e classes de ativos.",
    loadFailed: "Não foi possível carregar os ativos. Tente novamente.",
    assetClassHint: "Aplica-se a todas as posições de {{symbol}}. Escolha Automático para remover a alteração.",
    searchPlaceholder: "Pesquisar por símbolo ou nome",
    empty: "Nenhum ativo corresponde a estes filtros.",
    count: "{{count}} ativos",
    count_one: "{{count}} ativo",
    count_other: "{{count}} ativos",
    loadMore: "Carregar mais",
    loadingMore: "A carregar…",
    columns: {
      assetClass: "Classe de ativo",
    },
    filters: {
      type: "Tipo",
      allTypes: "Todos os tipos",
      account: "Conta",
      allAccounts: "Todas as contas",
      assetClass: "Classe de ativo",
      allAssetClasses: "Todas as classes",
      includeClosed: "Mostrar posições fechadas",
      clear: "Limpar filtros",
    },
    status: {
      debtTermsMissing: "Faltam termos de dívida",
      label: "Filtrar por estado",
      stale: "Preço desatualizado",
      incomeMissing: "Faltam termos de rendimento",
      dividendOverride: "Dividendo alterado",
      lotMismatch: "Divergência de lotes",
      assetClassOverridden: "Classe de ativo alterada",
    },
    chips: {
      noPrice: "Ainda sem preço",
    },
    actions: {
      addIncomeTerms: "Adicionar termos de rendimento",
      addDebtTerms: "Adicionar termos de dívida",
      menu: "Ações para {{symbol}}",
      price: "Atualizar preço",
      history: "Histórico de preços",
      assetClass: "Classe de ativo",
      copyTrading: "Mudar para Copy Trading",
    },
    attention: {
      title: "{{count}} itens precisam da sua atenção",
      title_one: "{{count}} item precisa da sua atenção",
      title_other: "{{count}} itens precisam da sua atenção",
      allClear: "Tudo em dia",
      allClearHint: "Os preços estão atualizados e cada empréstimo e posição com rendimento tem os seus termos.",
      stale: "Preços a atualizar",
      debtTermsMissing: "Empréstimos sem termos",
      incomeMissing: "Faltam termos de rendimento",
      lotMismatch: "Divergências de lotes a rever",
    },
    sort: {
      label: "Ordenar",
      attention: "Primeiro o que precisa de atenção",
      name: "A–Z",
    },
    detached: {
      title: "{{count}} conjuntos de termos de rendimento estão desvinculados",
      title_one: "{{count}} conjunto de termos de rendimento está desvinculado",
      title_other: "{{count}} conjuntos de termos de rendimento estão desvinculados",
      description: "Uma reconstrução da carteira não conseguiu associá-los a uma posição. Volte a vinculá-los ou descarte-os.",
      review: "Rever",
      hide: "Ocultar",
    },
  },

  // Processing status (#100): header chip, page banners, Settings → Processing
  activity: {
    types: {
      PORTFOLIO_UPDATE: "Atualizando carteira",
      ANALYTICS_UPDATE: "Atualizando análises",
      BANK_SYNC: "Sincronizando banco",
      IMPORT: "Importando transações",
      SECURITY_DATA: "Atualizando dados de mercado",
      SUBSCRIPTION_SCAN: "Analisando assinaturas",
      INSIGHTS: "Gerando insights",
    },
    stages: {
      scheduling: "Agendando",
      recalculating_lots: "Recalculando lotes",
      updating_cash: "Atualizando caixa",
      valuing_assets: "Avaliando ativos",
      updating_debts: "Atualizando dívidas",
      updating_analytics: "Atualizando análises",
      fetching_bank: "Buscando transações bancárias",
      syncing_copies: "Sincronizando cópias do eToro",
      classifying: "Classificando transações",
      processing_file: "Processando arquivo",
      committing: "Salvando transações",
      refreshing_market_data: "Atualizando dados de mercado",
      scanning: "Analisando",
      generating_insights: "Gerando insights",
    },
    triggers: {
      user_change: "Sua alteração",
      bank_sync: "Sincronização bancária",
      import: "Importação",
      nightly: "Noturno",
      manual_rebuild: "Reconstrução",
      agent: "Agente de IA",
      auto_refresh: "Atualização automática",
    },
    states: {
      queued: "Na fila",
      running: "Atualizando",
      stalled: "Demorando mais que o normal",
      completed: "Concluído",
      failed: "Falhou",
    },
    chip: {
      queued: "Na fila",
      running: "Atualizando",
      stalled: "Demorando mais que o normal",
      failed: "Falha na atualização",
      ariaLabel: "Status do processamento em segundo plano",
      title: "Processamento em segundo plano",
      empty: "Tudo está atualizado",
      lastUpdated: "Última atualização {{time}}",
      jobs: "{{count}} tarefas",
      workerOffline: "O processo em segundo plano está offline. As tarefas na fila começam quando ele voltar.",
      failedHint: "Erro {{code}}. Administradores veem os detalhes em Configurações → Processamento.",
      pending: "Iniciando…",
    },
    banner: {
      queued: "Os números desta página serão recalculados em instantes ({{label}}). Eles serão atualizados automaticamente.",
      running: "Os números desta página estão sendo recalculados ({{label}}). Eles serão atualizados automaticamente.",
      runningProgress: "Os números desta página estão sendo recalculados ({{label}}, {{progress}}%). Eles serão atualizados automaticamente.",
      stalled: "O recálculo está demorando mais que o normal ({{label}}). Os números podem estar desatualizados.",
      failed: "A última atualização dos dados desta página falhou ({{label}}). Os números podem estar desatualizados.",
      updated: "Atualizado {{time}}",
    },
    time: {
      justNow: "agora mesmo",
      underSecond: "< 1 s",
      minutesAgo: "há {{count}} min",
      hoursAgo: "há {{count}} h",
      daysAgo: "há {{count}} d",
      seconds: "{{count}} s",
      minutes: "{{count}} min",
      hours: "{{count}} h",
    },
    processing: {
      title: "Processamento",
      description: "Trabalho em segundo plano nos seus dados: o que está rodando agora, as últimas 24 horas e as reconstruções.",
      liveTitle: "Ao vivo",
      liveEmpty: "Nada está rodando. Seus dados estão atualizados.",
      recentTitle: "Últimas 24 horas",
      recentEmpty: "Nenhum trabalho em segundo plano nas últimas 24 horas.",
      rebuildsTitle: "Reconstruções recentes",
      unavailable: "O status do processamento não está disponível agora.",
      workerOffline: "O processo em segundo plano está offline. As tarefas na fila começam quando ele voltar.",
      elapsed: "rodando há {{time}}",
      queuedFor: "na fila há {{time}}",
      took: "levou {{time}}",
      finished: "terminou {{time}}",
      errorCode: "Erro {{code}}",
      steps_one: "{{count}} etapa",
      steps_other: "{{count}} etapas",
    },
    notification: {
      failed_one: "{{count}} atualização em segundo plano falhou",
      failed_other: "{{count}} atualizações em segundo plano falharam",
    },
    maintenance: {
      seeProgress: "Ver progresso",
      seeProgressHint: "O progresso ao vivo e o histórico de reconstruções estão em Processamento.",
    },
  },

  // Enable Banking (#132)
  // eToro copy trading (#143)
  etoro: {
    section: {
      title: "Copy trading do eToro",
      description: "Acompanhe o valor e a composição das suas cópias no eToro. O Bliss as lê com uma chave de leitura da sua própria conta eToro. Ele nunca opera e nunca cria transações.",
      connect: "Conectar eToro",
      empty: "Nenhuma conta eToro conectada ainda.",
      guide: "Como criar uma chave de leitura",
      loadFailed: "Não foi possível carregar suas conexões do eToro.",
    },
    status: {
      ACTIVE: "Conectada",
      NEEDS_RECONNECT: "Precisa de uma nova chave",
    },
    connection: {
      account: "Conta no Bliss",
      noAccount: "Sem conta",
      key: "Chave",
      lastSync: "Última sincronização",
      never: "Nunca",
      lastSyncFailed: "A última sincronização falhou ({{code}})",
      syncNow: "Sincronizar agora",
      syncStarted: "Sincronização iniciada. Os valores serão atualizados em alguns minutos.",
      cooldown: "Sincronizado há pouco. Tente de novo em {{minutes}} min.",
      replaceKey: "Trocar chave",
      remove: "Remover",
      removeTitle: "Remover esta conexão do eToro?",
      removeDescription: "O Bliss para de atualizar suas cópias. Suas posições de Copy Trading e o histórico continuam.",
      removeConfirm: "Remover",
      removed: "Conexão do eToro removida",
      copies: "Cópias",
      noCopies: "Nenhuma cópia nesta conta.",
    },
    copy: {
      closed: "Encerrada no eToro",
      linkedTo: "Vinculada a {{symbol}}",
      notLinked: "Não vinculada",
      notLinkedHint: "Registre esta cópia como posição de Copy Trading com o ticker {{username}} nesta conta, ou mude um fundo existente para Copy Trading em Gerenciar ativos.",
      startedAt: "Desde {{date}}",
    },
    dialog: {
      title: "Conectar eToro",
      replaceTitle: "Trocar a chave do eToro",
      description: "Crie uma chave de leitura no eToro (Configurações → Trading → Gerenciamento de chaves de API) e cole os dois valores. O Bliss recusa chaves que podem operar.",
      apiKey: "Chave de API",
      userKey: "Chave de usuário",
      userKeyHint: "Guardada criptografada e nunca mostrada novamente.",
      account: "Conta no Bliss",
      accountHint: "A conta onde você registra suas cópias do eToro.",
      accountPlaceholder: "Escolha uma conta",
      submit: "Conectar",
      replaceSubmit: "Salvar chave",
      checking: "Verificando com o eToro…",
      successTitle: "Conectado como {{username}}",
      successCopies_one: "{{count}} cópia encontrada",
      successCopies_other: "{{count}} cópias encontradas",
      noCopies: "Ainda não há cópias nesta conta.",
      done: "Concluído",
      cancel: "Cancelar",
    },
    errors: {
      ETORO_WRITE_SCOPE: "Esta chave pode operar. Crie uma chave de leitura no eToro e use essa.",
      ETORO_KEY_INVALID: "O eToro não aceitou esta chave. Confira os dois valores e se ela não expirou.",
      ETORO_UNAVAILABLE: "Não foi possível falar com o eToro. Tente mais tarde.",
      ETORO_RATE_LIMITED: "O eToro está limitando as requisições. Tente em um minuto.",
      ETORO_ALREADY_CONNECTED: "Esta conta eToro já está conectada.",
      ETORO_DIFFERENT_LOGIN: "Esta chave pertence a outra conta eToro.",
      KEYS_REQUIRED: "Informe as duas chaves.",
      ACCOUNT_REQUIRED: "Escolha uma conta no Bliss.",
      generic: "Algo deu errado. Tente de novo.",
    },
    badge: {
      linked: "Vinculada ao eToro",
      needsReconnect: "A chave do eToro precisa ser trocada",
      closed: "Cópia encerrada no eToro",
      notLinked: "Não vinculada ao eToro",
      lastValue: "Valor do eToro de {{date}}",
    },
    convert: {
      title: "Mudar para Copy Trading",
      description: "Mova {{symbol}} para a categoria Copy Trading. As transações, os termos de renda e o histórico continuam como estão. Quando sua conta eToro estiver conectada, o Bliss acompanha o valor e a composição da cópia.",
      username: "Usuário do eToro do investidor que você copia",
      usernamePlaceholder: "@investidor",
      pickCopy: "Escolha a cópia",
      otherInvestor: "Outro investidor",
      matched: "corresponde ao nome",
      otherAccount: "Sua conexão com o eToro usa a conta {{account}}. Este ativo está em outra conta, então não será vinculado após a troca: mova antes as transações dele para {{account}}.",
      submit: "Mudar",
      success: "{{symbol}} agora é uma posição de Copy Trading",
      errors: {
        INVALID_USERNAME: "Informe um usuário do eToro válido.",
        COPY_HOLDING_EXISTS: "Esta conta já tem uma posição para esse investidor.",
        COPY_TRADING_CATEGORY_MISSING: "A categoria Copy Trading está faltando. Peça ao administrador do Bliss para adicioná-la.",
        generic: "Não foi possível mudar esta posição. Tente de novo.",
      },
    },
  },
  enableBanking: {
    connect: {
      button: "Conectar banco da UE (Enable Banking)",
      title: "Conectar um banco europeu",
      description: "Escolha seu banco. Você será levado ao site dele para aprovar o acesso somente leitura via Enable Banking.",
      search: "Buscar bancos",
      loading: "Carregando bancos...",
      loadFailed: "Não foi possível carregar a lista de bancos. Tente novamente mais tarde.",
      noBanks: "Nenhum banco encontrado para os países do seu espaço.",
      startDate: "As transações serão importadas a partir de",
      consentDays_one: "O acesso dura até {{count}} dia; depois será preciso reconectar.",
      consentDays_other: "O acesso dura até {{count}} dias; depois será preciso reconectar.",
      continue: "Continuar para o banco",
      redirecting: "Redirecionando...",
      errorCountryNotEnabled: "O país deste banco não está habilitado no seu espaço.",
      errorUnknownBank: "Este banco não está mais disponível. Escolha outro.",
      errorGeneric: "Não foi possível iniciar a conexão com o banco. Tente novamente mais tarde.",
    },
    callback: {
      reconnectedTitle: "Reconectado — sincronizando",
      reconnectedDesc: "O acesso ao seu banco foi renovado e uma sincronização foi iniciada.",
      errorTitle: "Falha na conexão com o banco",
      invalid_state: "O link de conexão expirou ou já foi usado. Comece novamente em Contas.",
      denied: "O acesso não foi concedido no seu banco. Nada foi conectado.",
      exchange_failed: "Seu banco não confirmou a conexão. Tente novamente em alguns minutos.",
      not_enabled: "O Enable Banking não está configurado para o seu espaço. Um administrador pode adicioná-lo em Configurações → Sincronização bancária.",
      unknown: "Algo deu errado ao conectar seu banco.",
    },
    mapping: {
      title: "Vincule suas contas bancárias",
      description: "Escolha em qual conta do Bliss cada conta de {{bank}} será sincronizada.",
      loading: "Carregando contas...",
      loadFailed: "Não foi possível carregar esta conexão. Tente novamente mais tarde.",
      unnamed: "Conta bancária",
      balance: "Saldo {{amount}}",
      syncInto: "Sincronizar em",
      existingAccounts: "Contas existentes",
      createNew: "Criar nova conta",
      dontSync: "Não sincronizar",
      linkedPlaid: "sincronizada via Plaid",
      linkedEnableBanking: "sincronizada via outra conexão",
      switchHint: "Esta conta é sincronizada por outra conexão. Vinculá-la aqui move a sincronização para este banco; o histórico é mantido.",
      conflict: "Já sincronizada pela conexão de outra pessoa — autorize uma conta conjunta com apenas um titular.",
      newName: "Nome da conta",
      newBank: "Banco",
      newCountry: "País",
      newCurrency: "Moeda",
      createBankOption: "Adicionar \"{{name}}\"",
      noAccounts: "Seu banco não retornou nenhuma conta.",
      submit: "Vincular contas",
      submitting: "Vinculando...",
      successTitle: "Contas vinculadas — sincronizando",
      successDesc_one: "{{count}} conta será sincronizada. A primeira sincronização foi iniciada.",
      successDesc_other: "{{count}} contas serão sincronizadas. A primeira sincronização foi iniciada.",
      successNoneDesc: "Nenhuma conta foi vinculada. Você pode vinculá-las depois a partir desta conexão.",
      errorAlreadyConnected: "Uma destas contas bancárias já é sincronizada por outra conexão.",
      errorDuplicate: "Duas contas bancárias não podem sincronizar na mesma conta do Bliss.",
      errorCreateIncomplete: "Preencha nome, banco, país e moeda de cada nova conta.",
      errorGeneric: "Não foi possível vincular as contas. Tente novamente.",
      switchTitle: "Trocar o provedor de sincronização?",
      switchDesc: "Estas contas deixarão de sincronizar pelo provedor atual e passarão a sincronizar via Enable Banking. O histórico existente é mantido.",
      switchFrom: "Atualmente sincronizada via {{provider}} ({{bank}})",
      switchConfirm: "Trocar e vincular",
      providerPlaid: "Plaid",
      providerEnableBanking: "Enable Banking",
    },
    card: {
      title: "Conexão Enable Banking",
      statusActive: "Ativa",
      statusExpiring: "Expira em breve",
      statusExpired: "Expirada",
      statusError: "Erro",
      statusDisconnected: "Desconectada",
      statusNeedsMapping: "Falta vincular",
      expiringDesc: "O acesso ao banco termina em breve. Reconecte para continuar sincronizando.",
      expiredDesc: "O acesso ao banco terminou. Reconecte para retomar a sincronização.",
      errorDesc: "A última sincronização falhou. Tente novamente mais tarde ou reconecte.",
      needsMappingDesc: "Escolha quais contas do Bliss este banco alimenta antes de sincronizar.",
      bank: "Banco",
      accessExpires: "Acesso expira",
      expiresIn_one: "{{date}} (falta {{count}} dia)",
      expiresIn_other: "{{date}} (faltam {{count}} dias)",
      lastSync: "Última sincronização",
      balanceAsOf: "em {{date}}",
      syncNow: "Sincronizar agora",
      syncStarted: "Sincronização iniciada",
      syncStartedDesc: "As novas transações aparecerão em breve.",
      syncFailed: "Falha ao iniciar a sincronização",
      syncNotActive: "Reconecte este banco antes de sincronizar.",
      syncNoAccounts: "Vincule pelo menos uma conta antes de sincronizar.",
      budgetTitle: "Limite diário de atualizações atingido",
      budgetDesc: "Seu banco permite apenas algumas atualizações por dia. Você poderá sincronizar novamente após {{time}}.",
      budgetDescNoTime: "Seu banco permite apenas algumas atualizações por dia. Tente novamente amanhã.",
      reconnect: "Reconectar",
      reconnectOnlyAuthoriser: "Somente a pessoa que autorizou esta conexão pode reconectá-la.",
      reconnectFailed: "Não foi possível iniciar a reconexão. Tente novamente mais tarde.",
      mapAccounts: "Vincular contas",
      manageAccounts: "Gerenciar contas",
      disconnect: "Desconectar",
      disconnecting: "Desconectando...",
      disconnectOnlyAdmin: "Somente um administrador ou a pessoa que autorizou esta conexão pode desconectá-la.",
      disconnectTitle: "Desconectar {{bank}}?",
      disconnectDesc: "A sincronização para e o acesso ao banco é encerrado. Suas contas e o histórico de transações são mantidos.",
      disconnected: "Banco desconectado",
      disconnectedDesc: "A sincronização parou. Suas contas e o histórico são mantidos.",
      disconnectFailed: "Falha ao desconectar",
      statusPaused: "Em pausa",
      pausedDesc: "Em pausa: credenciais em falta.",
      pausedAdminLink: "Configurar a sincronização bancária",
      pausedAskAdmin: "Peça a um administrador que adicione as credenciais do Enable Banking.",
    },
    pending: {
      message: "{{bank}} está conectado, mas nenhuma conta foi vinculada ainda. Escolha quais contas sincronizar.",
    },
    detail: {
      badge: "Enable Banking",
      deleteBlockedHint: "Desconecte esta conexão bancária primeiro (use \"Desconectar\" acima) antes de excluir a conta.",
    },
    credentials: {
      title: "Enable Banking (bancos da UE)",
      intro: "Sincronize automaticamente contas de bancos da UE com a sua própria aplicação Enable Banking. Uma aplicação gratuita pode ligar até 5 contas.",
      guideLink: "Ler o guia de configuração",
      callbackLabel: "URL de retorno",
      callbackHint: "Registe este URL como URL de redirecionamento na sua aplicação Enable Banking.",
      copy: "Copiar",
      copied: "Copiado",
      appIdLabel: "Id da aplicação",
      appIdInvalid: "O id da aplicação é um UUID, como 6f0c1a2b-3c4d-4e5f-8a9b-0c1d2e3f4a5b.",
      keyLabel: "Chave privada",
      save: "Guardar e verificar",
      saving: "A verificar...",
      cancel: "Cancelar",
      statusVERIFIED: "Verificadas",
      statusUNVERIFIED: "Não verificadas",
      statusINVALID: "Inválidas",
      unverifiedDesc: "Não foi possível contactar o Enable Banking para verificar estas credenciais. Estão guardadas; use Verificar novamente para tentar outra vez.",
      invalidDesc: "O Enable Banking rejeitou estas credenciais. As sincronizações agendadas estão em pausa até as verificar novamente ou substituir.",
      callbackMissing: "O URL de retorno ainda não está registado nesta aplicação. As ligações bancárias vão falhar até estar.",
      appId: "Id da aplicação",
      fingerprint: "Impressão digital da chave",
      keyBits: "RSA de {{bits}} bits",
      lastValidated: "Última verificação",
      never: "Nunca",
      linkedAccounts: "Contas ligadas",
      linkedAccountsValue: "{{used}} de {{limit}}",
      activeConnections: "Ligações ativas",
      replace: "Substituir credenciais",
      reverify: "Verificar novamente",
      remove: "Remover",
      replaceHint: "Para trocar apenas a chave, mantenha o id da aplicação e carregue o novo ficheiro.",
      savedTitle: "O Enable Banking está configurado",
      savedDesc: "O seu espaço já pode ligar bancos da UE a partir de Contas.",
      savedUnverifiedDesc: "Guardadas, mas não foi possível contactar o Enable Banking para as verificar. Use Verificar novamente mais tarde.",
      verifiedTitle: "Credenciais verificadas",
      stillInvalidTitle: "O Enable Banking continua a rejeitar estas credenciais",
      stillUnverifiedTitle: "Não foi possível contactar o Enable Banking",
      removedTitle: "Credenciais removidas",
      removedDesc: "As ligações ficam em pausa até serem adicionadas novas credenciais.",
      errorINVALID_CREDENTIALS: "O Enable Banking rejeitou estas credenciais. Confirme que a chave privada pertence a esta aplicação.",
      errorSANDBOX_APP: "Esta é uma aplicação de sandbox. Crie uma aplicação de produção em modo restrito.",
      errorINVALID_APP_ID: "O id da aplicação é um UUID, como 6f0c1a2b-3c4d-4e5f-8a9b-0c1d2e3f4a5b.",
      errorGeneric: "Não foi possível guardar as credenciais. Tente novamente.",
      loadFailed: "Não foi possível carregar as configurações do Enable Banking.",
      confirmAppChangeTitle: "Mudar a aplicação Enable Banking?",
      confirmAppChangeDesc_one: "{{count}} ligação deixará de sincronizar até ser religada. As suas contas e o histórico são mantidos.",
      confirmAppChangeDesc_other: "{{count}} ligações deixarão de sincronizar até serem religadas. As suas contas e o histórico são mantidos.",
      confirmRemoveTitle: "Remover as credenciais do Enable Banking?",
      confirmRemoveDesc_one: "{{count}} ligação ficará em pausa até serem adicionadas novas credenciais. Contas, associações e transações são mantidas.",
      confirmRemoveDesc_other: "{{count}} ligações ficarão em pausa até serem adicionadas novas credenciais. Contas, associações e transações são mantidas.",
      confirmContinue: "Continuar",
      pausedBanner_one: "{{count}} ligação está em pausa até adicionar as suas credenciais do Enable Banking.",
      pausedBanner_other: "{{count}} ligações estão em pausa até adicionar as suas credenciais do Enable Banking.",
      historyTitle: "Histórico de alterações",
      historyEmpty: "Ainda sem alterações.",
      historySET: "Configuradas",
      historyREPLACED: "Substituídas",
      historyKEY_ROTATED: "Chave trocada",
      historyREMOVED: "Removidas",
      historyBy: "por {{name}}",
      historyUnknownUser: "um antigo membro",
      notification: "As credenciais do Enable Banking precisam de atenção",
      setupLink: "Configurar a sincronização de bancos da UE",
    },
    keyInput: {
      drop: "Largue aqui o ficheiro .pem do Enable Banking",
      choose: "Escolher ficheiro",
      pasteInstead: "Colar em vez disso",
      uploadInstead: "Carregar um ficheiro em vez disso",
      pasteLabel: "Chave privada (PEM)",
      valid: "Chave privada RSA válida · {{bits}} bits",
      clear: "Remover",
      readFailed: "Não foi possível ler este ficheiro.",
      errorKEY_NOT_PEM: "Isto não é uma chave privada PEM.",
      errorKEY_PUBLIC: "Isto é uma chave pública. Use a chave privada (.pem) que o Enable Banking lhe deu.",
      errorKEY_CERTIFICATE: "Isto é um certificado, não uma chave privada.",
      errorKEY_NOT_RSA: "Só são suportadas chaves privadas RSA.",
      errorKEY_ENCRYPTED: "Chaves protegidas por palavra-passe não são suportadas. Use o .pem não cifrado do Enable Banking.",
      errorKEY_TRUNCATED: "A chave parece incompleta: falta a linha END ou o texto foi cortado.",
      errorKEY_TOO_LARGE: "Tem mais de 16 KB, demasiado para uma chave privada.",
      errorKEY_TOO_SMALL: "As chaves RSA têm de ter pelo menos 2048 bits.",
    },
    settings: {
      historyDaysHint: "Também se aplica às conexões Enable Banking.",
    },
  },
  // Installable PWA (#155)
  pwa: {
    install: {
      button: "Instalar app",
      settingsTitle: "App do Bliss",
      settingsDescription: "Instale o Bliss para abri-lo em sua própria janela, pela tela de início, pelo Dock ou pela barra de tarefas.",
      bannerTitle: "Instale o app do Bliss",
      bannerDescription: "Abra o Bliss em sua própria janela, pela tela de início, pelo Dock ou pela barra de tarefas.",
      dismiss: "Dispensar",
      iosTitle: "Adicione o Bliss à Tela de Início",
      iosStep1: "Toque no botão Compartilhar na barra do navegador.",
      iosStep2: "Role para baixo e toque em “Adicionar à Tela de Início”.",
      iosStep3: "Toque em “Adicionar”. O Bliss aparece na sua Tela de Início.",
      iosSignInNote: "O app não compartilha o login do navegador, então você entra uma vez dentro do app.",
      done: "Entendi",
    },
    update: {
      reload: "Recarregar",
    },
    banks: {
      desktopOnly: "Conecte e reconecte bancos em um navegador no computador. As transações sincronizadas ainda podem ser revisadas aqui.",
    },
    offline: {
      title: "Você está offline",
      description: "O Bliss precisa de conexão para mostrar seus dados. Seus números voltam a carregar assim que você estiver online.",
      retry: "Tentar novamente",
    },
  },
  // Onboarding wizard (#154): every step, namespaced
  onboarding: {
    welcome: {
      title: "Bem-vindo ao",
      subtitle: "Vamos personalizar sua experiência",
      countries: "Seus países",
      currencies: "Suas moedas",
    },
    connect: {
      title: "Conecte suas contas",
      subtitle: "Vincule um banco para sincronização automática, importe uma planilha ou adicione contas manualmente",
      bankTitle: "Conecte seu banco",
      bankDescription: "Escolha o provedor que atende seu banco. Você pode adicionar o outro depois.",
      learnMore: "Saiba mais",
      plaid: {
        title: "Plaid — bancos dos EUA, Canadá e Reino Unido",
        description: "Vincule suas contas bancárias com segurança pelo Plaid para sincronizar as transações automaticamente.",
        button: "Conectar conta bancária",
        notConfigured: "O Plaid não está configurado neste servidor.",
        notConfiguredHint: "O administrador do servidor adiciona as chaves do Plaid; o guia explica como.",
        error: "Não foi possível acessar o Plaid, tente novamente mais tarde.",
      },
      enableBanking: {
        title: "Enable Banking — bancos da UE",
        description: "Vincule bancos da UE por consentimento PSD2, usando seu próprio aplicativo Enable Banking.",
        connect: "Conectar banco da UE",
        setup: "Configurar a sincronização de bancos da UE",
        adminOnly: "Um administrador do espaço de trabalho pode configurar a sincronização de bancos da UE em Configurações.",
      },
      setup: {
        title: "Configurar a sincronização de bancos da UE",
        description: "O Bliss se conecta a bancos da UE pelo seu próprio aplicativo Enable Banking. Adicione o ID e a chave privada: o Bliss verifica antes de salvar e depois você escolhe seu banco.",
        needTitle: "O que você precisa",
        needAccount: "Uma conta Enable Banking",
        needApp: "Um aplicativo de produção em modo restrito",
        needCallback: "A URL de retorno abaixo registrada nesse aplicativo",
        limit: "O modo restrito vincula até 5 contas bancárias suas.",
        guide: "Guia passo a passo",
      },
      importTitle: "Importar uma planilha",
      importDescription: "Envie um arquivo CSV ou Excel com suas transações.",
    },
    accounts: {
      title: "Adicione seus bancos e contas",
      subtitle: "Escolha os bancos que você usa e adicione uma conta para cada um. Você pode preencher os números das contas depois.",
      selectBanks: "Selecione seus bancos",
      addDifferentBank: "Adicionar outro banco",
      bankName: "Nome do banco",
      account: "Conta",
      addAccount: "Adicionar conta",
      removeAccount: "Remover conta",
      removeBank: "Remover banco",
      bankCap: "Você pode adicionar até {{count}} bancos aqui; poderá adicionar mais depois.",
      pickCountry: "Escolha o país de cada conta; o padrão é {{country}}.",
      createdIn: "As contas serão criadas em {{country}}.",
      skip: "Pular por enquanto",
      create_one: "Criar {{count}} conta",
      create_other: "Criar {{count}} contas",
    },
    errors: {
      noTenant: "Espaço de trabalho não encontrado",
      tenantMissing: "Nome ou plano do espaço de trabalho ausente. Entre em contato com o suporte.",
      savePreferences: "Não foi possível salvar suas preferências. Tente novamente.",
      noUser: "Não foi possível identificar seu usuário. Tente novamente.",
      setupAccounts: "Não foi possível configurar suas contas. Tente novamente.",
    },
  },
};

export default pt;
